import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  TextField,
  MenuItem,
  Button,
  Grid,
  Box,
  Paper,
  Typography,
  IconButton,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  FormControl,
  InputLabel,
  FormControlLabel,
  Radio,
  RadioGroup,
  Autocomplete,
  Tooltip,
  FormHelperText,
  Dialog,
  DialogTitle,
  DialogContent,
  CircularProgress,
  Fade,
  Drawer,
} from "@mui/material";
import noItemImg from "../../images/noItem.png";
import CloseIcon from "@mui/icons-material/Close";
import DescriptionIcon from "@mui/icons-material/Description";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import GradingIcon from "@mui/icons-material/Grading";
import Badge from "@mui/material/Badge";
import LibraryAddCheckIcon from "@mui/icons-material/LibraryAddCheck";
import DeleteIcon from "@mui/icons-material/Delete";
import ScienceIcon from "@mui/icons-material/Science";
import DiscountIcon from "@mui/icons-material/Discount";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import { BASE_URL } from "../../constants";
import { FILE_RULES, validateFile } from "../../utils/fileValidation";
import axios from "axios";
import { format } from "date-fns";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import AddIcon from "@mui/icons-material/Add";
import Checkbox from "@mui/material/Checkbox";
import LocalPrintshopIcon from "@mui/icons-material/LocalPrintshop";
import { createInvoice, createAdvice, createBoth } from "../Invoices/createPdf";
import { useRecoilValue } from "recoil";
import { authState } from "../../recoil/authAtom";
import { toast } from "react-toastify";
import parse from "autosuggest-highlight/parse";
import match from "autosuggest-highlight/match";
import MaleIcon from "@mui/icons-material/Male";
import FemaleIcon from "@mui/icons-material/Female";
import TransgenderIcon from "@mui/icons-material/Transgender";
import { Edit } from "@mui/icons-material";
import ClearIcon from "@mui/icons-material/Clear";
import ReceiptIcon from "@mui/icons-material/Receipt";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import PersonIcon from "@mui/icons-material/Person";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
import ApartmentIcon from "@mui/icons-material/Apartment";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ReceiptOutlinedIcon from "@mui/icons-material/ReceiptOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined";

const INITIAL_STATE = {
  name: "",
  qualifications: [""],
  regId: "",
  note: "",
  consultFees: 0,
  isConsultant: false,
  isSignatory: false,
  signatoryCat: "Pathology",
  signFile: null,
  signHeader: "",
};
const INITIAL_STATE_P = {
  name: "",
  dob: "",
  age: "",
  gender: "",
  mobile: "",
  address: "",
  aadhar: "",
};
const INITIAL_STATE_C = {
  centreName: "",
  centreAddress: "",
  centreContactPerson: "",
  centreContactNumber: "",
};
const LabTest = () => {
  const user = useRecoilValue(authState);
  const location = useLocation();
  const navigate = useNavigate();
  const invoice = location?.state?.invoice || null;
  const [formData, setFormData] = useState({
    patientId: null,
    doctorId: null,
    centerId: null,
  });
  const doctorInputRef = useRef(null);
  const addToBillRef = useRef(null);
  const submitBtnRef = useRef(null);
  const updateBtnRef = useRef(null);
  const selectTestRef = useRef(null);
  const [selectedTest, setSelectedTest] = useState(null);
  const [openConfirmModal, setOpenConfirmModal] = useState(false);
  const [isBillSummaryOpen, setIsBillSummaryOpen] = useState(false);
  const [billItems, setBillItems] = useState([]);
  const [discount, setDiscount] = useState(0);
  const [discountType, setDiscountType] = useState("%");
  const [testHeaders, setTestHeaders] = useState([]);
  const [patients, setPatients] = useState([]);
  const [doctors, setDoctors] = useState([]);
  const [centers, setCenters] = useState([]);
  const [note, setNote] = useState("");
  const [amountCollected, setAmountCollected] = useState(null);
  const [sampleCollectedDate, setSampleCollectedDate] = useState(
    format(new Date(), "MMMM dd, yyyy"),
  );
  const [displayPrintOptions, setDisplayPrintOptions] = useState(false);
  const [invoiceIdToPrint, setInvoiceIdToPrint] = useState("");
  const [checked, setChecked] = useState(false);
  const [patientSearchInput, setPatientSearchInput] = useState("");
  const [patientSuggestions, setPatientSuggestions] = useState([]);
  const [loadingPatients, setLoadingPatients] = useState(false);
  const [doctorSearchInput, setDoctorSearchInput] = useState("");
  const [doctorSuggestions, setDoctorSuggestions] = useState([]);
  const [loadingDoctors, setLoadingDoctors] = useState(false);
  const [defaultCentre, setDefaultCentre] = useState(true);

  const [openPatientModal, setOpenPatientModal] = useState(true);
  const [openDoctorModal, setOpenDoctorModal] = useState(false);
  const [openCenterModal, setOpenCenterModal] = useState(false);
  const [highlightedIndex, setHighlightedIndex] = useState(0);
  const testInputRef = useRef(null);

  useEffect(() => {
    if (patientSuggestions.length > 0) {
      setHighlightedIndex(0);
    } else {
      setHighlightedIndex(-1);
    }
  }, [patientSuggestions]);

  const handlePatientKeyDown = (e) => {
    if (!patientSuggestions.length) return;

    if (e.key === "ArrowDown") {
      e.preventDefault();
      setHighlightedIndex((prev) =>
        prev < patientSuggestions.length - 1 ? prev + 1 : 0,
      );
    }

    if (e.key === "ArrowUp") {
      e.preventDefault();
      setHighlightedIndex((prev) =>
        prev > 0 ? prev - 1 : patientSuggestions.length - 1,
      );
    }

    if (e.key === "Enter") {
      e.preventDefault();

      const selected = patientSuggestions[highlightedIndex];
      if (selected) {
        setFormData((prev) => ({
          ...prev,
          patientId: selected._id,
        }));
        setPatientSearchInput(selected.name);
        setOpenPatientModal(false);

        // ✅ MOVE FOCUS TO DOCTOR
        setTimeout(() => {
          doctorInputRef.current?.focus();
          setOpenDoctorModal(true);
        }, 150);
      }
    }
  };

  useEffect(() => {
    if (invoice) {
      setOpenPatientModal(false);
      setFormData({
        ...formData,
        patientId: invoice?.patient,
        doctorId: invoice?.doctor,
        centerId: invoice?.center,
      });
      const updatedTests = invoice?.tests?.map((test) => ({
        ...test?.testId,
        changedPrice: test?.changedPrice,
        discountType: test?.discount?.type,
        discountValue: test?.discount?.value,
      }));
      setBillItems(updatedTests || []);
      setDiscountType(invoice?.invoiceDiscount?.type || "%");
      setDiscount(invoice?.invoiceDiscount?.value || 0);
      setSampleCollectedDate(
        invoice?.billingDate || format(new Date(), "MMMM dd, yyyy"),
      );
      setChecked(invoice?.isAmountCollectedAtCenter);
    }
  }, [invoice]);
  const handleDateChange = (newDate) => {
    if (newDate) {
      const formattedDate = dayjs(newDate).format("MMMM DD, YYYY");
      setSampleCollectedDate(formattedDate);
    }
  };

  useEffect(() => {
    setLoadingPatients(false);
    if (patientSearchInput.trim()) {
      setLoadingPatients(true);
      const delayDebounce = setTimeout(async () => {
        try {
          const res = await fetch(
            `${BASE_URL}api/user/common/patients/search?query=${patientSearchInput}`,
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
              },
            },
          );
          const patients = await res.json();
          setPatientSuggestions(patients.data);
        } catch (err) {
          console.error("Error fetching patients:", err);
          setPatientSuggestions([]);
        } finally {
          setLoadingPatients(false);
        }
      }, 500); // debounce

      return () => clearTimeout(delayDebounce);
    } else {
      setPatientSuggestions([]);
    }
  }, [patientSearchInput]);

  const handleSelectPatient = (event, newValue) => {
    if (newValue?._id) {
      setFormData((prev) => ({
        ...prev,
        patientId: newValue._id,
      }));

      // 🔥 show only clean name in input
      setPatientSearchInput(newValue.name);
    } else {
      setFormData((prev) => ({
        ...prev,
        patientId: null,
      }));
    }
  };
  useEffect(() => {
    setLoadingDoctors(false);
    if (doctorSearchInput.trim()) {
      setLoadingDoctors(true);
      const delayDebounce = setTimeout(async () => {
        try {
          const res = await fetch(
            `${BASE_URL}api/user/common/doctors/search?query=${doctorSearchInput}`,
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
              },
            },
          );
          const doctors = await res.json();
          setDoctorSuggestions(doctors.data);
        } catch (err) {
          console.error("Error fetching doctors:", err);
          setDoctorSuggestions([]);
        } finally {
          setLoadingDoctors(false);
        }
      }, 500); // debounce

      return () => clearTimeout(delayDebounce);
    } else {
      setDoctorSuggestions([]);
    }
  }, [doctorSearchInput]);

  const handleSelectDoctor = async (event, newValue) => {
    if (newValue?._id) {
      setFormData({ ...formData, doctorId: newValue._id });
    } else {
      setFormData((prev) => ({
        ...prev,
        doctorId: null,
      }));
    }
  };

  const fetchTestHeaders = async () => {
    try {
      const response = await axios.get(
        `${BASE_URL}api/user/common/test-header-bill`,
        {
          headers: {},
        },
      );
      setTestHeaders(response.data.data);
    } catch (error) {
      console.error("Error fetching test headers:", error);
    } finally {
    }
  };

  const [centerSearchInput, setCenterSearchInput] = useState("");
  const [centerSuggestions, setCenterSuggestions] = useState([]);
  const [loadingCenters, setLoadingCenters] = useState(false);
  useEffect(() => {
    setLoadingCenters(false);
    if (centerSearchInput.trim()) {
      setLoadingCenters(true);
      const delayDebounce = setTimeout(async () => {
        try {
          const res = await fetch(
            `${BASE_URL}api/user/common/centers/search?query=${centerSearchInput}`,
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
              },
            },
          );
          const centers = await res.json();
          setCenterSuggestions(centers.data);
        } catch (err) {
          console.error("Error fetching centers:", err);
          setCenterSuggestions([]);
        } finally {
          setLoadingCenters(false);
        }
      }, 500); // debounce

      return () => clearTimeout(delayDebounce);
    } else {
      setPatientSuggestions([]);
    }
  }, [centerSearchInput]);

  const handleSelectCenter = (event, newValue) => {
    if (newValue?._id) {
      setFormData((prev) => ({
        ...prev,
        centerId: newValue._id,
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        centerId: null,
      }));
    }
  };
  useEffect(() => {
    fetchTestHeaders();
  }, []);

  const [defaultCenterData, setDefaultCenterData] = useState(null);
  const fetchDefaultCentre = async () => {
    try {
      const response = await axios.get(
        `${BASE_URL}api/user/common/get-default-centre`,
        {
          headers: {},
        },
      ); // change URL if needed
      if (response.data.success) {
        setDefaultCenterData(response.data.data);
        setFormData((prev) => ({
          ...prev,
          centerId: response?.data?.data?._id,
        }));
      } else {
        setDefaultCenterData(null);
      }
    } catch (err) {
      console.error("Error fetching default centre:", err);
    }
  };
  useEffect(() => {
    fetchDefaultCentre();
  }, []);

  const handleAmountCollection = (e) => {
    if (parseInt(e.target.value) > parseInt(discountedTotal)) return;
    setAmountCollected(e.target.value);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      return;
      e.preventDefault(); // Prevent form submission
      addToBill();
    }
  };

  const handleTestChange = (e) => {
    setSelectedTest(e.target.value);
  };

  const addToBill = () => {
    const testDetails = testHeaders?.find(
      (option) => option._id === selectedTest._id,
    );

    if (
      testDetails &&
      !billItems?.some((item) => item._id === selectedTest._id)
    ) {
      setBillItems((prev) => {
        const updatedItems = [
          {
            ...testDetails,
            changedPrice: testDetails?.testPrice,
            discountType: "%",
            discountValue: 0,
          },
          ...prev,
        ];
        setHighlightedIndex(0); // Newly added item will be at index 0
        setTimeout(() => {
          setHighlightedIndex(null);
        }, 500);
        return updatedItems;
      });

      setSelectedTest(null);
      setTimeout(() => {
        selectTestRef.current?.focus();
      }, 100);
    }
  };

  const removeFromBill = (id) => {
    setBillItems((prev) => prev?.filter((item) => item._id !== id));
  };

  const handleDiscountChange = (id, key, value) => {
    setBillItems((prev) =>
      prev.map((item) => (item._id === id ? { ...item, [key]: value } : item)),
    );
  };

  const calculateDiscountedPrice = (item) => {
    const { discountType, discountValue, testPrice, changedPrice } = item;
    const finalTestPrice = changedPrice || testPrice;
    if (discountType === "%") {
      return finalTestPrice - (finalTestPrice * discountValue) / 100;
    }
    if (discountType === "₹") {
      return finalTestPrice - discountValue;
    }
    return finalTestPrice;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
  };

  const handleDiscountChangeTotal = (event) => {
    const value = event.target.value;
    // Only allow numeric values
    if (!isNaN(value) && value >= 0) {
      setDiscount(value);
    }
  };

  const handleDiscountTypeChange = (event) => {
    setDiscountType(event.target.value);
  };

  const totalAmount = billItems
    ?.reduce((total, item) => total + calculateDiscountedPrice(item), 0)
    .toFixed(2);

  let discountedTotal;
  if (discountType === "%") {
    discountedTotal = (totalAmount - (totalAmount * discount) / 100).toFixed(2);
  } else {
    discountedTotal = (totalAmount - discount).toFixed(2);
  }
  const submitBillAPI = async () => {
    try {
      setLoading(true);
      if (!formData?.patientId) {
        toast.error("Please select a patient");
        setLoading(false);
        return;
      }
      if (!formData?.doctorId) {
        toast.error("Please select a doctor");
        setLoading(false);
        return;
      }
      if (!formData?.centerId) {
        toast.error("Please select a center");
        setLoading(false);
        return;
      }
      if (billItems?.length === 0) {
        toast.error("Please add at least 1 test in the bill");
        setLoading(false);
        return;
      }

      const obj = {
        pathology: true,
        radiology: true,
        microbiology: true,
        widal: true,
      };
      billItems.forEach((item) => {
        if (obj.hasOwnProperty(item.testCat)) {
          obj[item.testCat] = false;
        }
        if (item.reportType === "Widal" && item.testCat == "pathology") {
          obj.widal = false;
        }
      });
      const data = {
        patientId: formData.patientId,
        doctorId: formData.doctorId,
        centerId: formData.centerId,
        tests: billItems.map((bill) => {
          return {
            testId: bill._id,
            discount: {
              type: bill.discountType,
              value: Number(bill.discountValue),
            },
            changedPrice: bill.changedPrice,
          };
        }),
        invoiceDiscount: {
          type: discountType,
          value: Number(discount),
        },
        invoiceNote: note,
        isColledtedAtCenter: checked,
        paidAmount: [
          {
            amt: amountCollected ? amountCollected : 0,
            date: sampleCollectedDate,
          },
        ],
        billingDate: sampleCollectedDate,
        isPathSubmit: obj.pathology,
        isRadioSubmit: obj.radiology,
        isMicroSubmit: obj.microbiology,
        isWidSubmit: obj.widal,
        createdBy: localStorage.getItem("userId"),
      };
      const response = await axios.post(
        `${BASE_URL}api/user/common/create-invoice`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      if (response?.data?.success) {
        toast.success(response?.data?.message);
        setInvoiceIdToPrint(response.data.invoice._id);
        setDisplayPrintOptions(true);
      } else {
        toast.error(response?.data?.message || "Failed to create invoice");
      }
    } catch (error) {
      console.error(
        "Error creating invoice:",
        error.response?.data || error.message,
      );
      toast.error("Failed to create invoice. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  const updateBill = async (id) => {
    if (!invoice?.allowEdit) {
      alert(
        "Cannot update invoice. One or more test reports have already been generated.",
      );
      return;
    }
    try {
      setLoading(true);
      const obj = {
        pathology: true,
        radiology: true,
        microbiology: true,
        widal: true,
      };

      billItems.forEach((item) => {
        if (obj.hasOwnProperty(item.testCat)) {
          obj[item.testCat] = false;
        }
        if (item.reportType === "Widal" && item.testCat == "pathology") {
          obj.widal = false;
        }
      });

      const data = {
        patientId: formData.patientId._id
          ? formData.patientId._id
          : formData.patientId,
        doctorId: formData.doctorId._id
          ? formData.doctorId._id
          : formData.doctorId,
        centerId: formData.centerId._id
          ? formData.centerId._id
          : formData.centerId,
        tests: billItems.map((bill) => {
          return {
            testId: bill._id,
            discount: {
              type: bill.discountType,
              value: Number(bill.discountValue),
            },
            changedPrice: bill.changedPrice,
          };
        }),
        invoiceDiscount: {
          type: discountType,
          value: Number(discount),
        },
        invoiceNote: note,
        paidAmount: [
          {
            amt: amountCollected ? amountCollected : 0,
            date: sampleCollectedDate,
          },
        ],
        billingDate: sampleCollectedDate,
        isPathSubmit: obj.pathology,
        isRadioSubmit: obj.radiology,
        isMicroSubmit: obj.microbiology,
        isWidSubmit: obj.widal,
        updatedBy: localStorage.getItem("userId"),
      };
      const response = await axios.post(
        `${BASE_URL}api/user/common/update-invoice/${id}`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      if (response.data.success) {
        toast.success("Invoice updated successfully!");
      } else {
        toast.error("Failed to update invoice. Please try again.");
      }
    } catch (error) {
      console.error(
        "Error updating invoice:",
        error.response?.data || error.message,
      );
      toast.error("Failed to update invoice. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredProducts, setFilteredProducts] = useState(testHeaders);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  // const [highlightedIndex, setHighlightedIndex] = useState(null);

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    setHighlightedIndex(-1); // Reset highlighted index on new search
    if (value.trim() === "") {
      setFilteredProducts(testHeaders);
    } else {
      const filtered = testHeaders?.filter((product) =>
        product.testName.toLowerCase().includes(value.toLowerCase()),
      );
      setFilteredProducts(filtered);
    }
  };

  const [patientData, setPatientData] = useState(INITIAL_STATE_P);
  const [doctorData, setDoctorData] = useState(INITIAL_STATE);
  const [centerData, setCenterData] = useState(INITIAL_STATE_C);
  const [showPatientRegisterButton, setShowPatientRegisterButton] =
    useState(false);
  const [patientForm, setPatientForm] = useState(false);
  const [doctorForm, setDoctorForm] = useState(false);
  const [centerForm, setCenterForm] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [errorsPatient, setErrorsPatient] = useState({});
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [showRegisterButton, setShowRegisterButton] = useState(false);
  const [showCenterRegisterButton, setShowCenterRegisterButton] =
    useState(false);
  const handleQualificationChange = (index, value) => {
    const updatedQualifications = [...doctorData.qualifications];
    updatedQualifications[index] = value;
    setDoctorData({ ...doctorData, qualifications: updatedQualifications });
  };

  const addQualification = () => {
    setDoctorData({
      ...doctorData,
      qualifications: [...doctorData.qualifications, ""],
    });
  };
  const removeQualification = (index) => {
    const updatedQualifications = doctorData.qualifications?.filter(
      (_, i) => i !== index,
    );
    setDoctorData({ ...doctorData, qualifications: updatedQualifications });
  };
  const handleNewChange = (e) => {
    setDoctorData({
      ...doctorData,
      [e.target.name]: e.target.value,
    });
  };
  const handleCloseDrawer = () => {
    setIsDrawerOpen(false);
    setPatientForm(false);
    setDoctorForm(false);
    setCenterForm(false);
    setDoctorSearchInput("");
    setPatientSearchInput("");
    setCenterSearchInput("");
  };
  const filteredPatients = patients?.filter((patient) =>
    `${patient.name} ${patient.patientID} ${patient.mobile}`
      .toLowerCase()
      .includes(patientSearchInput.toLowerCase()),
  );

  // const filteredPatients = patients?.filter((patient) => {
  //   const input = patientSearchInput.trim().toLowerCase();

  //   // Match either name or mobile separately
  //   const nameMatch = patient.name?.toLowerCase().includes(input);
  //   const mobileMatch = patient.mobile?.includes(input); // mobile is already a string

  //   return nameMatch || mobileMatch;
  // });

  const filteredDoctor = doctors?.filter((doc) =>
    `${doc.name} (${doc.regId})`
      .toLowerCase()
      .includes(doctorSearchInput.toLowerCase()),
  );

  const filteredCenter = centers?.filter((doc) =>
    `${doc.centreName} (${doc.centerId})`
      .toLowerCase()
      .includes(centerSearchInput.toLowerCase()),
  );

  const handleChangePatient = (e) => {
    if (e.target.name === "age") {
      if (patientData.dob === "") {
        return setPatientData({
          ...patientData,
          [e.target.name]: e.target.value,
        });
      } else {
        return setPatientData({ ...patientData, age: e.target.value, dob: "" });
      }
    }
    setPatientData({
      ...patientData,
      [e.target.name]: e.target.value,
    });
  };

  const handleChangeCenter = (e) => {
    return setCenterData({
      ...centerData,
      [e.target.name]: e.target.value,
    });
  };

  const calculateAge1 = (dob) => {
    if (!dob) return "Enter a valid DOB";
    const birthDate = dayjs(dob, "DD-MM-YYYY");
    const now = dayjs();
    const years = now.diff(birthDate, "year");
    const months = now.diff(birthDate.add(years, "year"), "month");
    return `${years} years and ${months} months`;
  };
  const calculateAge = (dob) => {
    const birthDate = dayjs(dob, "DD-MM-YY");
    const now = dayjs();
    const years = now.diff(birthDate, "year");
    const months = now.diff(birthDate.add(years, "year"), "month");
    const days = now.diff(
      birthDate.add(years, "year").add(months, "month"),
      "day",
    );
    return `${years}Y ${months}M ${days}D`;
  };

  const handleDateChangePatient1 = (newValue) => {
    const date = dayjs(newValue).format("DD-MM-YYYY");
    if (patientData.age === "") {
      return setPatientData({ ...patientData, dob: date });
    } else {
      return setPatientData({ ...patientData, dob: date, age: "" });
    }
  };
  const handleDateChangePatient = (newValue) => {
    const formattedDate = dayjs(newValue).format("DD-MM-YY"); // Display in "DD-MM-YY" format
    if (patientData.age === "") {
      return setPatientData({ ...patientData, dob: formattedDate });
    } else {
      return setPatientData({ ...patientData, dob: formattedDate, age: "" });
    }
  };

  const handleGenderChange = (e) => {
    const { value } = e.target;
    setPatientData({ ...patientData, gender: value });
  };
  const validatePatientForm = () => {
    const newErrors = {};

    if (!patientData.name) {
      newErrors.name = "Patient name is required.";
    }
    if (!patientData.dob && !patientData.age) {
      newErrors.dob = "required.";
      newErrors.age = "required.";
    }
    if (!patientData.gender) {
      newErrors.gender = "Patient gender is required.";
    }

    setErrorsPatient(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const [patientLoading, setPatientLoading] = useState(false);
  const handleSubmitPatient = async (e) => {
    e.preventDefault();
    if (validatePatientForm()) {
      let data = patientData;

      if (patientData.dob) {
        const formattedDob = dayjs(patientData.dob, "DD-MM-YY").format(
          "MMMM DD, YYYY",
        );
        data = { ...data, dob: formattedDob };
      }

      if (parseInt(patientData.age) > 0) {
        const currentYear = new Date().getFullYear();
        const currentMonth = new Date().getMonth();
        const currentdate = new Date().getDate();
        const yearOfBirth = currentYear - parseInt(patientData.age);
        const dob = new Date(yearOfBirth, currentMonth, currentdate);
        const formattedDob = `${dob.toLocaleString("en-US", {
          month: "long",
        })} ${dob.getDate().toString().padStart(2, "0")}, ${dob.getFullYear()}`;

        data = {
          ...data,
          dob: formattedDob,
          // patientRefId: patientRef?._id || null,
        };
      }
      delete data.age;

      try {
        setPatientLoading(true);
        const response = await fetch(
          `${BASE_URL}api/user/common/patient-register`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
          },
        );

        const resp = await response.json();

        if (resp.success) {
          alert(resp.message);
          setPatientSearchInput(patientData.name);
          setPatientData(INITIAL_STATE);
          setIsDrawerOpen(false);
          setPatients([...patients, resp.patient]);
          setIsDrawerOpen(false);
          setFormData((prev) => ({ ...prev, patientId: resp.patient._id }));
          setPatientForm(false);
        } else {
          alert("Error: " + resp.message);
        }
      } catch (error) {
        alert("Something went wrong! Please try again.");
      } finally {
        setPatientLoading(false);
      }
    }
  };

  const [doctorLoading, setDoctorLoading] = useState(false);
  const handleDoctorSubmit = async (e) => {
    e.preventDefault();
    console.log("Doctor new");
    if (validateForm()) {
      setDoctorLoading(true);
      const formData = new FormData();
      for (const key in doctorData) {
        if (Array.isArray(doctorData[key])) {
          doctorData[key].forEach((item, index) => {
            formData.append(`${key}[${index}]`, item); // Correctly appending array values
          });
        } else {
          formData.append(key, doctorData[key]);
        }
      }
      try {
        const response = await fetch(
          `${BASE_URL}api/user/common/doctor-register`,
          {
            method: "POST",
            headers: {},
            body: formData, // Send FormData directly
          },
        );

        const data = await response.json();

        if (data.success) {
          alert(data.message);
          setDoctorData(INITIAL_STATE);
          setDoctorSearchInput(doctorData.name);
          setDoctors([...doctors, data.doctor]);
          setIsDrawerOpen(false);
          setFormData((prev) => ({ ...prev, doctorId: data.doctor._id }));
          setDoctorForm(false);
        } else {
          alert("Error: " + data.message);
        }
      } catch (error) {
        console.error("Error:", error);
        alert("Something went wrong! Please try again.");
      } finally {
        setDoctorLoading(false);
      }
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!doctorData.name) {
      newErrors.name = "Doctor name is required.";
    }
    if (!doctorData.qualifications.some((q) => q.trim())) {
      newErrors.qualifications = "At least 1 qualification is required.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const [centerLoading, setCenterLoading] = useState(false);
  const handleSubmitCenter = async (e) => {
    e.preventDefault();
    setCenterLoading(true);
    try {
      const response = await fetch(`${BASE_URL}api/user/common/create-center`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(centerData),
      });

      const data = await response.json();

      if (data.success) {
        alert(data.message);
        setCenterData(INITIAL_STATE_C);
        setCenterSearchInput(centerData.centreName);
        setCenters([...centers, data.center]);
        setIsDrawerOpen(false);
        setFormData((prev) => ({ ...prev, centerId: data.center._id }));
        setCenterData(false);
      } else {
        alert("Error: " + data.message);
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Something went wrong! Please try again.");
    } finally {
      setCenterLoading(false);
    }
  };

  const cancelEditHandler = () => {
    setFormData({
      patientId: null,
      doctorId: null,
      centerId: null,
    });
    setBillItems([]);
    navigate(location.pathname, { replace: true, state: null });
  };

  const handleSignFileChange = async (e) => {
    const file = e.target.files[0];
    const result = await validateFile(file, FILE_RULES.signature);
    if (!result.valid) {
      alert(result.error);
      e.target.value = "";
      return;
    }
    setDoctorData({
      ...doctorData,
      signFile: file,
    });
  };

  const handleCheckBoxChange = (event) => {
    setChecked(event.target.checked);
  };

  const [printLoading, setPrintLoading] = useState(false);
  const printInvoice = async (id) => {
    setPrintLoading(true);
    try {
      const response = await fetch(
        `${BASE_URL}api/user/common/get-invoice/${
          selectedInvoiceToPrint || id
        }`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      const data = await response.json();
      createInvoice(data.invoice, paperSize, orientation);
      logPrintInvoice(data.invoice._id);
    } catch (error) {
      console.error("Error:", error);
      alert("Something went wrong! Please try again.");
    } finally {
      setPrintLoading(false);
    }
  };
  const printAdvice = async (id) => {
    setPrintLoading(true);
    try {
      const response = await fetch(
        `${BASE_URL}api/user/common/get-invoice/${selectedAdviceToPrint || id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      const data = await response.json();
      createAdvice(data.invoice, paperSize, orientation);
      logPrintAdvice(data.invoice._id);
    } catch (error) {
      console.error("Error:", error);
      alert("Something went wrong! Please try again.");
    } finally {
      setPrintLoading(false);
    }
  };
  const printBoth = async (id) => {
    setPrintLoading(true);
    try {
      const response = await fetch(
        `${BASE_URL}api/user/common/get-invoice/${id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      const data = await response.json();
      // createAdvice(data.invoice, paperSize, orientation);
      // createInvoice(data.invoice, paperSize, orientation);
      createBoth(data.invoice, paperSize, orientation);
      logPrintBoth(data.invoice._id);
    } catch (error) {
      console.error("Error:", error);
      alert("Something went wrong! Please try again.");
    } finally {
      setPrintLoading(false);
    }
  };

  const logPrintInvoice = async (id) => {
    try {
      const response = await fetch(`${BASE_URL}api/user/common/log-print`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id, print: "Invoice" }),
      });
    } catch (error) {
      console.log(error);
    }
  };
  const logPrintAdvice = async (id) => {
    try {
      const response = await fetch(`${BASE_URL}api/user/common/log-print`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id, print: "Advice" }),
      });
    } catch (error) {
      console.log(error);
    }
  };

  const logPrintBoth = async (id) => {
    try {
      const response = await fetch(`${BASE_URL}api/user/common/log-print`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id, print: "Both" }),
      });
    } catch (error) {
      console.log(error);
    }
  };
  const [openModal, setOpenModal] = useState(false);
  const [selectedInvoiceToPrint, setSelectedInvoiceToPrint] = useState("");
  const [selectedAdviceToPrint, setSelectedAdviceToPrint] = useState("");
  const [paperSize, setPaperSize] = useState("a5");
  const [orientation, setOrientation] = useState("landscape");
  const handleInvoiceClick = async (id) => {
    setOpenModal(true);
    setSelectedAdviceToPrint("");
    setSelectedInvoiceToPrint(id);
  };
  const handleAdviceClick = async (id) => {
    setOpenModal(true);
    setSelectedInvoiceToPrint("");
    setSelectedAdviceToPrint(id);
  };

  const handleBothClick = async (id) => {
    // setOpenModal(true);
    // setSelectedInvoiceToPrint("");
    // setSelectedAdviceToPrint(id);
    // printInvoice(id);
    // printAdvice(id);
    printBoth(id);
  };

  const [openPriceEdit, setOpenPriceEdit] = useState(false);
  const [selectedTestForPriceEdit, setSelectedTestForPriceEdit] =
    useState(null);
  const [newPrice, setNewPrice] = useState(null);
  const [editPriceLoading, setEditPriceLoading] = useState(false);

  const changePrice = (test) => {
    setOpenPriceEdit(true);
    setSelectedTestForPriceEdit(test);
  };
  const [hover, setHover] = useState(false);

  const handleChangeClick = async () => {
    const id = selectedTestForPriceEdit?._id;
    if (!selectedTestForPriceEdit?._id || !newPrice) {
      toast.error("Test and new price are required");
      return;
    }
    setBillItems((prev) =>
      prev.map((item) =>
        item._id === id ? { ...item, changedPrice: newPrice } : item,
      ),
    );
    toast.success("Test price changed");
    setOpenPriceEdit(false);
  };
  const getGenderIcon = (gender) => {
    const g = gender.toLowerCase();
    switch (g) {
      case "male":
        return <MaleIcon sx={{ color: "#2563eb" }} />;
      case "female":
        return <FemaleIcon sx={{ color: "#db2777" }} />;
      case "others":
        return <TransgenderIcon sx={{ color: "#7c3aed" }} />;
      default:
        return "";
    }
  };

  const showAge = (dob) => {
    const birthDate = dayjs(dob, "MMMM DD, YYYY");
    const today = dayjs();

    const years = today.diff(birthDate, "year");
    const months = today.diff(birthDate.add(years, "year"), "month");
    const days = today.diff(
      birthDate.add(years, "year").add(months, "month"),
      "day",
    );
    return `${years}Y ${months}M ${days}D`;
  };

  const [changeCenterClicked, setChangeCenterClicked] = useState(false);
  const [changeDoctorClicked, setChangeDoctorClicked] = useState(false);

  const [anchorEl, setAnchorEl] = useState(null);

  const [selectedInvoiceId, setSelectedInvoiceId] = useState(null);

  const handleOpen = (event, invoiceId) => {
    setAnchorEl(event.currentTarget);
    setSelectedInvoiceId(invoiceId);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDoctorKeyDown = (e) => {
    if (!doctorSuggestions.length) return;

    if (e.key === "ArrowDown") {
      e.preventDefault();
      setHighlightedIndex((prev) =>
        prev < doctorSuggestions.length - 1 ? prev + 1 : 0,
      );
    }

    if (e.key === "ArrowUp") {
      e.preventDefault();
      setHighlightedIndex((prev) =>
        prev > 0 ? prev - 1 : doctorSuggestions.length - 1,
      );
    }

    if (e.key === "Enter") {
      e.preventDefault();

      const selected = doctorSuggestions[highlightedIndex];
      if (selected) {
        setFormData((prev) => ({
          ...prev,
          doctorId: selected._id,
        }));
        setDoctorSearchInput(selected.name);
        setOpenDoctorModal(false);
      }
    }
  };

  useEffect(() => {
    const handleShortcut = (e) => {
      const isSave = (e.ctrlKey || e.metaKey) && e.key.toLowerCase() === "s";
      if (isSave) {
        e.preventDefault();
        if (invoice) return;
        setOpenConfirmModal(true);
      }
    };
    window.addEventListener("keydown", handleShortcut);
    return () => {
      window.removeEventListener("keydown", handleShortcut);
    };
  }, [invoice]);

  const open = Boolean(anchorEl);

  const searchFieldStyle = {
    "& .MuiOutlinedInput-root": {
      borderRadius: "10px",
      background: "#ffffff",
      fontSize: "0.875rem",
      "& fieldset": { borderColor: "#e5e9ef" },
      "&:hover fieldset": { borderColor: "#2a54a6" },
      "&.Mui-focused fieldset": {
        borderColor: "#b93acf",
        borderWidth: "1.5px",
      },
    },
    "& .MuiInputLabel-root": { fontSize: "0.85rem", color: "#94a3b8" },
    "& .MuiInputLabel-root.Mui-focused": { color: "#b93acf" },
  };
  const disabledFieldStyle = {
    ...searchFieldStyle,
    "& .MuiOutlinedInput-root": {
      ...searchFieldStyle["& .MuiOutlinedInput-root"],
      background: "#f8fafc",
    },
  };
  const editBtnSx = {
    width: 34,
    height: 34,
    borderRadius: "10px",
    flexShrink: 0,
    background: "rgba(16,185,129,0.1)",
    border: "1.5px solid rgba(16,185,129,0.25)",
    color: "#059669",
    "&:hover": {
      background: "rgba(16,185,129,0.2)",
      borderColor: "rgba(16,185,129,0.4)",
    },
  };
  const clearBtnSx = {
    width: 34,
    height: 34,
    borderRadius: "10px",
    flexShrink: 0,
    background: "rgba(239,68,68,0.08)",
    border: "1.5px solid rgba(239,68,68,0.2)",
    color: "#dc2626",
    "&:hover": {
      background: "rgba(239,68,68,0.15)",
      borderColor: "rgba(239,68,68,0.35)",
    },
  };
  const optionRowSx = {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    p: "10px 14px",
    borderBottom: "1px solid #f1f5f9",
    width: "100%",
    gap: "3px",
    "&:hover": { background: "rgba(42,84,166,0.04)" },
    cursor: "pointer",
  };
  const HL = ({ parts }) =>
    parts.map((p, i) => (
      <span
        key={i}
        style={{
          fontWeight: p.highlight ? 700 : 400,
          background: p.highlight
            ? "linear-gradient(135deg,rgba(42,84,166,0.15),rgba(185,58,207,0.1))"
            : "transparent",
          color: p.highlight ? "#0a1f44" : "inherit",
          padding: p.highlight ? "1px 3px" : 0,
          borderRadius: "3px",
        }}
      >
        {p.text}
      </span>
    ));
  const RegisterBtn = ({ label, onClick }) => (
    <Button
      size="small"
      onClick={onClick}
      startIcon={<PersonAddIcon sx={{ fontSize: "0.82rem !important" }} />}
      sx={{
        background: "linear-gradient(135deg, #0f6e56, #1d9e75)", // 🔥 green gradient
        color: "#fff",
        textTransform: "none",
        fontSize: "0.78rem",
        fontWeight: 600,
        borderRadius: "8px",
        px: 1.6,
        py: 0.5,
        boxShadow: "0 4px 12px rgba(16,185,129,0.3)",
      }}
    >
      {label}
    </Button>
  );

  const CenterRegisterBtn = ({ label, onClick }) => (
    <Button
      size="small"
      onClick={onClick}
      startIcon={<ApartmentIcon sx={{ fontSize: "0.82rem !important" }} />}
      sx={{
        background: "linear-gradient(135deg, #0f6e56, #1d9e75)", // 🔥 green gradient
        color: "#fff",
        textTransform: "none",
        fontSize: "0.78rem",
        fontWeight: 600,
        borderRadius: "8px",
        px: 1.6,
        py: 0.5,
        boxShadow: "0 4px 12px rgba(16,185,129,0.3)",
      }}
    >
      {label}
    </Button>
  );

  const handleCenterKeyDown = (e) => {
    if (!centerSuggestions.length) return;

    if (e.key === "ArrowDown") {
      e.preventDefault();
      setHighlightedIndex((prev) =>
        prev < centerSuggestions.length - 1 ? prev + 1 : 0,
      );
    }

    if (e.key === "ArrowUp") {
      e.preventDefault();
      setHighlightedIndex((prev) =>
        prev > 0 ? prev - 1 : centerSuggestions.length - 1,
      );
    }

    if (e.key === "Enter") {
      e.preventDefault();

      const selected = centerSuggestions[highlightedIndex];
      if (selected) {
        setFormData((prev) => ({
          ...prev,
          centerId: selected._id,
        }));

        setCenterSearchInput(selected.centreName);
        setOpenCenterModal(false);
      }
    }
  };
  return (
    <>
      <Dialog
        open={openPriceEdit}
        onClose={() => setOpenPriceEdit(false)}
        maxWidth="xs"
        fullWidth
      >
        {/* ── HEADER ── */}
        <Box
          sx={{
            px: 2,
            py: 1.5,
            borderBottom: "1px solid #e5e9ef",
            background: "#ffffff",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Box>
            <Typography
              sx={{
                fontSize: "0.85rem",
                fontWeight: 700,
                color: "#0a1f44",
              }}
            >
              Update Price
            </Typography>

            <Typography sx={{ fontSize: "0.7rem", color: "#94a3b8" }}>
              {selectedTestForPriceEdit?.testName}
            </Typography>
          </Box>

          <IconButton
            size="small"
            onClick={() => setOpenPriceEdit(false)}
            sx={{
              borderRadius: "8px",
              border: "1px solid #e5e9ef",
              p: "5px",
            }}
          >
            <CloseIcon sx={{ fontSize: "1rem", color: "#94a3b8" }} />
          </IconButton>
        </Box>

        {/* ── CONTENT ── */}
        <DialogContent
          sx={{
            p: 2,
            background: "#f8fafc",
          }}
        >
          <Grid container spacing={1.5}>
            {/* CURRENT PRICE */}
            <Grid item xs={12}>
              <Typography
                sx={{ fontSize: "0.7rem", color: "#64748b", mb: 0.5 }}
              >
                Current Price
              </Typography>

              <Box
                sx={{
                  p: 1.2,
                  borderRadius: "10px",
                  background: "#ecfdf5",
                  border: "1px solid #bbf7d0",
                  fontWeight: 700,
                  color: "#059669",
                  fontSize: "0.9rem",
                }}
              >
                ₹{" "}
                {selectedTestForPriceEdit?.changedPrice ||
                  selectedTestForPriceEdit?.testPrice}
              </Box>
            </Grid>

            {/* NEW PRICE */}
            <Grid item xs={12}>
              <Typography
                sx={{ fontSize: "0.7rem", color: "#64748b", mb: 0.5 }}
              >
                New Price
              </Typography>

              <TextField
                fullWidth
                size="small"
                type="number"
                placeholder="Enter new price"
                onChange={(e) => setNewPrice(e.target.value)}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "10px",
                    background: "#ffffff",

                    "& fieldset": {
                      borderColor: "#e5e9ef",
                    },

                    "&:hover fieldset": {
                      borderColor: "#16a34a",
                    },

                    "&.Mui-focused fieldset": {
                      borderColor: "#22c55e",
                      boxShadow: "0 0 0 2px rgba(34,197,94,0.15)",
                    },
                  },
                }}
              />
            </Grid>
          </Grid>

          {/* ── ACTION BUTTON ── */}
          <Button
            fullWidth
            disabled={editPriceLoading}
            onClick={handleChangeClick}
            sx={{
              mt: 2,
              height: 40,
              borderRadius: "10px",
              fontWeight: 700,
              textTransform: "none",

              background: "linear-gradient(135deg,#f59e0b,#f97316)",
              color: "#fff",

              boxShadow: "0 6px 18px rgba(249,115,22,0.35)",

              "&:hover": {
                background: "linear-gradient(135deg,#d97706,#ea580c)",
              },
            }}
          >
            {editPriceLoading ? (
              <CircularProgress size={18} sx={{ color: "#fff" }} />
            ) : (
              "Update Price"
            )}
          </Button>
        </DialogContent>
      </Dialog>
      <Dialog
        open={openModal}
        onClose={() => setOpenModal(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>Choose paper particulars</DialogTitle>
        <DialogContent
          sx={{
            paddingTop: "10px !important",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <FormControl fullWidth>
            <InputLabel>Paper Size</InputLabel>
            <Select
              value={paperSize}
              onChange={(e) => setPaperSize(e.target.value)}
            >
              <MenuItem value="a4">A4</MenuItem>
              <MenuItem value="a5">A5</MenuItem>
            </Select>
          </FormControl>

          <FormControl fullWidth sx={{ marginLeft: "10px" }}>
            <InputLabel>Orientation</InputLabel>
            <Select
              value={orientation}
              onChange={(e) => setOrientation(e.target.value)}
            >
              <MenuItem value="portrait">Portrait</MenuItem>
              <MenuItem value="landscape">Landscape</MenuItem>
            </Select>
          </FormControl>
          {selectedInvoiceToPrint &&
            (!printLoading ? (
              <IconButton size="small" sx={{ ml: 1 }}>
                <LocalPrintshopIcon
                  onClick={printInvoice}
                  sx={{
                    cursor: "pointer",
                    color: "#26a96c",
                    fontSize: "2.2rem",
                  }}
                />
              </IconButton>
            ) : (
              "Printing..."
            ))}
          {selectedAdviceToPrint &&
            (!printLoading ? (
              <IconButton size="small" sx={{ ml: 1 }}>
                <LocalPrintshopIcon
                  onClick={printAdvice}
                  sx={{
                    cursor: "pointer",
                    color: "#26a96c",
                    fontSize: "2.2rem",
                  }}
                />
              </IconButton>
            ) : (
              "Printing..."
            ))}
        </DialogContent>
      </Dialog>

      <Dialog
        open={openCenterModal}
        onClose={() => setOpenCenterModal(false)}
        maxWidth="sm"
        fullWidth
      >
        {/* HEADER (MATCH DOCTOR) */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            px: 2,
            py: 1.2,
            borderBottom: "1px solid #e5e9ef",
            background: "#ffffff",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Box
              sx={{
                width: 28,
                height: 28,
                borderRadius: "8px",
                background: "linear-gradient(135deg,#2a54a6,#b93acf)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 3px 8px rgba(185,58,207,0.25)",
              }}
            >
              <ApartmentIcon sx={{ color: "#fff", fontSize: 16 }} />
            </Box>

            <Box>
              <Typography
                sx={{
                  fontSize: "0.85rem",
                  fontWeight: 700,
                  color: "#0a1f44",
                  lineHeight: 1.2,
                }}
              >
                Select Center
              </Typography>

              <Typography
                sx={{
                  fontSize: "0.65rem",
                  color: "#94a3b8",
                }}
              >
                Search or register new center
              </Typography>
            </Box>
          </Box>

          <CenterRegisterBtn
            label="Register"
            onClick={() => {
              setCenterForm(true);
              setIsDrawerOpen(true);
              setOpenCenterModal(false);
            }}
          />
        </Box>

        {/* CONTENT */}
        <DialogContent>
          {/* SEARCH */}
          <TextField
            fullWidth
            placeholder="Search center..."
            value={centerSearchInput}
            onChange={(e) => setCenterSearchInput(e.target.value)}
            onKeyDown={handleCenterKeyDown}
            autoFocus
            size="small"
            sx={{ mb: 2 }}
          />

          {/* LOADING */}
          {loadingCenters ? (
            <CircularProgress size={20} />
          ) : (
            centerSuggestions.map((c, index) => (
              <Box
                key={c._id}
                sx={{
                  ...optionRowSx,
                  p: 1.2,
                  borderRadius: "8px",
                  mb: 0.5,

                  background:
                    index === highlightedIndex
                      ? "linear-gradient(135deg, rgba(42,84,166,0.12), rgba(185,58,207,0.1))"
                      : "#fff",

                  borderLeft:
                    index === highlightedIndex
                      ? "3px solid #b93acf"
                      : "3px solid transparent",

                  boxShadow:
                    index === highlightedIndex
                      ? "0 4px 10px rgba(185,58,207,0.15)"
                      : "0 1px 4px rgba(0,0,0,0.04)",

                  cursor: "pointer",
                  transition: "all 0.2s ease",

                  "&:hover": {
                    background: "rgba(42,84,166,0.06)",
                  },
                }}
                onMouseEnter={() => setHighlightedIndex(index)}
                onClick={() => {
                  setFormData((prev) => ({
                    ...prev,
                    centerId: c._id,
                  }));

                  setCenterSearchInput(c.centreName);
                  setOpenCenterModal(false);
                }}
              >
                {/* 🔥 TOP ROW */}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    width: "100%",
                  }}
                >
                  <Typography fontWeight={700} fontSize="0.85rem">
                    {c.centreName}
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: "0.7rem",
                      fontWeight: 600,
                      px: 1,
                      py: 0.2,
                      borderRadius: "6px",
                      background: "#eef2ff",
                      color: "#4f46e5",
                    }}
                  >
                    {c.centreId || "—"}
                  </Typography>
                </Box>
              </Box>
            ))
          )}
        </DialogContent>
      </Dialog>
      <Dialog
        open={isDrawerOpen}
        onClose={handleCloseDrawer}
        maxWidth="xs"
        fullWidth
      >
        {patientForm && (
          <Box
            component="form"
            sx={{ height: "100%", display: "flex", flexDirection: "column" }}
          >
            {/* ── Header ── */}
            <Box
              sx={{
                px: 2.5,
                py: 1.5,
                background: "#ffffff",
                borderBottom: "1px solid #e5e9ef",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexShrink: 0,
                position: "relative",
                "&::after": {
                  content: '""',
                  position: "absolute",
                  bottom: 0,
                  left: 0,
                  right: 0,
                  height: "2px",
                  background: "linear-gradient(90deg, #2a54a6, #b93acf)",
                },
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 1.25 }}>
                <Box
                  sx={{
                    width: 32,
                    height: 32,
                    borderRadius: "9px",
                    background: "linear-gradient(135deg, #0f6e56, #1d9e75)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                    boxShadow: "0 3px 10px rgba(185,58,207,0.25)",
                  }}
                >
                  <PersonAddIcon sx={{ color: "#fff", fontSize: "1rem" }} />
                </Box>
                <Box>
                  <Typography
                    sx={{
                      fontSize: "0.9rem",
                      fontWeight: 700,
                      color: "#0a1f44",
                      lineHeight: 1.2,
                    }}
                  >
                    Register Patient
                  </Typography>
                  <Typography
                    sx={{ fontSize: "0.62rem", color: "#94a3b8", mt: "1px" }}
                  >
                    Fill in the details below
                  </Typography>
                </Box>
              </Box>

              <IconButton
                onClick={handleCloseDrawer}
                size="small"
                sx={{
                  borderRadius: "8px",
                  border: "1px solid #e5e9ef",
                  p: "5px",
                  "&:hover": {
                    background: "rgba(239,68,68,0.07)",
                    borderColor: "rgba(239,68,68,0.25)",
                  },
                }}
              >
                <CloseIcon sx={{ fontSize: "1rem", color: "#94a3b8" }} />
              </IconButton>
            </Box>

            {/* ── Body ── */}
            <Box
              sx={{
                flex: 1,
                overflowY: "auto",
                p: 2.5,
                background: "#f8fafc",
                display: "flex",
                flexDirection: "column",
                gap: 0,
                "&::-webkit-scrollbar": { width: "3px" },
                "&::-webkit-scrollbar-thumb": {
                  background: "rgba(185,58,207,0.25)",
                  borderRadius: "4px",
                },
              }}
            >
              <Grid container spacing={1.75}>
                {/* Full Name */}
                <Grid item xs={12}>
                  <Typography sx={pLabelStyle}>
                    Full Name <Req />
                  </Typography>
                  <TextField
                    fullWidth
                    size="small"
                    placeholder="Patient's full name"
                    name="name"
                    onChange={handleChangePatient}
                    error={!!errorsPatient.name}
                    helperText={errorsPatient.name}
                    value={patientData.name}
                    sx={pFieldStyle}
                  />
                </Grid>

                {/* DOB + Age */}
                <Grid item xs={12}>
                  <Typography sx={pLabelStyle}>
                    Date of Birth / Age <Req />
                  </Typography>
                  <Box
                    sx={{ display: "flex", alignItems: "flex-start", gap: 1 }}
                  >
                    <FormControl sx={{ flex: 2 }} error={!!errorsPatient.dob}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          onChange={handleDateChangePatient}
                          format="DD-MM-YY"
                          maxDate={dayjs()}
                          value={
                            patientData.dob
                              ? dayjs(patientData.dob, "DD-MM-YY")
                              : null
                          }
                          slotProps={{
                            textField: {
                              size: "small",
                              placeholder: "DD-MM-YY",
                              error: !!errorsPatient.dob,
                              sx: pFieldStyle,
                            },
                          }}
                        />
                      </LocalizationProvider>
                    </FormControl>

                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        height: 40,
                        flexShrink: 0,
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: "0.65rem",
                          fontWeight: 700,
                          color: "#94a3b8",
                          letterSpacing: ".5px",
                        }}
                      >
                        OR
                      </Typography>
                    </Box>

                    <TextField
                      placeholder="Age"
                      size="small"
                      type="number"
                      name="age"
                      onChange={handleChangePatient}
                      value={patientData.age}
                      sx={{ ...pFieldStyle, width: "80px", flexShrink: 0 }}
                    />
                  </Box>
                </Grid>

                {/* Gender */}
                <Grid item xs={12}>
                  <Typography sx={pLabelStyle}>
                    Gender <Req />
                  </Typography>
                  <FormControl
                    fullWidth
                    size="small"
                    error={!!errorsPatient.gender}
                  >
                    <Select
                      value={patientData.gender || ""}
                      onChange={handleGenderChange}
                      name="gender"
                      displayEmpty
                      sx={{
                        borderRadius: "10px",
                        background: "#ffffff",
                        fontSize: "0.875rem",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#e5e9ef",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#2a54a6",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#b93acf",
                          borderWidth: "1.5px",
                        },
                      }}
                    >
                      <MenuItem
                        value=""
                        disabled
                        sx={{ fontSize: "0.875rem", color: "#94a3b8" }}
                      >
                        Select gender
                      </MenuItem>
                      {["Male", "Female", "Others"].map((g) => (
                        <MenuItem
                          key={g}
                          value={g}
                          sx={{ fontSize: "0.875rem" }}
                        >
                          {g}
                        </MenuItem>
                      ))}
                    </Select>
                    {errorsPatient.gender && (
                      <FormHelperText sx={{ fontSize: "0.72rem" }}>
                        {errorsPatient.gender}
                      </FormHelperText>
                    )}
                  </FormControl>
                </Grid>

                {/* Mobile */}
                <Grid item xs={12}>
                  <Typography sx={pLabelStyle}>
                    Mobile
                    <Box
                      component="span"
                      sx={{ color: "#94a3b8", fontWeight: 400, ml: 0.5 }}
                    >
                      (optional)
                    </Box>
                  </Typography>
                  <TextField
                    fullWidth
                    size="small"
                    placeholder="+91 00000 00000"
                    type="tel"
                    name="mobile"
                    onChange={handleChangePatient}
                    error={!!errorsPatient.mobile}
                    helperText={errorsPatient.mobile}
                    value={patientData.mobile}
                    sx={pFieldStyle}
                  />
                </Grid>

                {/* Address */}
                <Grid item xs={12}>
                  <Typography sx={pLabelStyle}>
                    Address
                    <Box
                      component="span"
                      sx={{ color: "#94a3b8", fontWeight: 400, ml: 0.5 }}
                    >
                      (optional)
                    </Box>
                  </Typography>
                  <TextField
                    fullWidth
                    size="small"
                    placeholder="Street, City"
                    name="address"
                    onChange={handleChangePatient}
                    error={!!errorsPatient.address}
                    helperText={errorsPatient.address}
                    value={patientData.address}
                    sx={pFieldStyle}
                  />
                </Grid>

                {/* Aadhar */}
                <Grid item xs={12}>
                  <Typography sx={pLabelStyle}>
                    Aadhar
                    <Box
                      component="span"
                      sx={{ color: "#94a3b8", fontWeight: 400, ml: 0.5 }}
                    >
                      (optional)
                    </Box>
                  </Typography>
                  <TextField
                    fullWidth
                    size="small"
                    placeholder="XXXX XXXX XXXX"
                    name="aadhar"
                    onChange={handleChangePatient}
                    error={!!errorsPatient.aadhar}
                    helperText={errorsPatient.aadhar}
                    value={patientData.aadhar}
                    sx={pFieldStyle}
                  />
                </Grid>
              </Grid>
            </Box>

            {/* ── Footer / Submit ── */}
            <Box
              sx={{
                px: 2.5,
                py: 2,
                background: "#ffffff",
                borderTop: "1px solid #e5e9ef",
                flexShrink: 0,
                display: "flex",
                gap: 1.5,
              }}
            >
              <Button
                fullWidth
                variant="outlined"
                onClick={handleCloseDrawer}
                sx={{
                  borderRadius: "10px",
                  textTransform: "none",
                  fontSize: "0.82rem",
                  fontWeight: 600,
                  borderColor: "#e5e9ef",
                  color: "#64748b",
                  "&:hover": { borderColor: "#94a3b8", background: "#f8fafc" },
                }}
              >
                Cancel
              </Button>
              <Button
                fullWidth
                variant="contained"
                onClick={handleSubmitPatient}
                disabled={patientLoading}
                startIcon={
                  patientLoading ? null : (
                    <PersonAddIcon sx={{ fontSize: "0.95rem !important" }} />
                  )
                }
                sx={{
                  borderRadius: "10px",
                  textTransform: "none",
                  fontSize: "0.85rem",
                  fontWeight: 700,
                  background: patientLoading
                    ? "#e5e9ef"
                    : "linear-gradient(135deg, #0f6e56, #1d9e75)",
                  color: patientLoading ? "#94a3b8" : "#ffffff",
                  boxShadow: patientLoading
                    ? "none"
                    : "0 4px 14px rgba(185,58,207,0.3)",
                  "&:disabled": { background: "#e5e9ef" },
                }}
              >
                {patientLoading ? "Submitting…" : "Register Patient"}
              </Button>
              {patientLoading && (
                <CircularProgress
                  size={18}
                  sx={{ color: "#b93acf", alignSelf: "center", flexShrink: 0 }}
                />
              )}
            </Box>
          </Box>
        )}
        {doctorForm && (
          <Box
            component="form"
            sx={{ height: "100%", display: "flex", flexDirection: "column" }}
          >
            {/* ── HEADER (MATCH PATIENT) ── */}
            <Box
              sx={{
                px: 2.5,
                py: 1.5,
                background: "#ffffff",
                borderBottom: "1px solid #e5e9ef",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                position: "relative",
                "&::after": {
                  content: '""',
                  position: "absolute",
                  bottom: 0,
                  left: 0,
                  right: 0,
                  height: "2px",
                  background: "linear-gradient(90deg, #2a54a6, #b93acf)",
                },
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 1.25 }}>
                <Box
                  sx={{
                    width: 32,
                    height: 32,
                    borderRadius: "9px",
                    background: "linear-gradient(135deg, #0f6e56, #1d9e75)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    boxShadow: "0 3px 10px rgba(16,185,129,0.25)",
                  }}
                >
                  <LocalHospitalIcon sx={{ color: "#fff", fontSize: "1rem" }} />
                </Box>

                <Box>
                  <Typography
                    sx={{
                      fontSize: "0.9rem",
                      fontWeight: 700,
                      color: "#0a1f44",
                    }}
                  >
                    Register Doctor
                  </Typography>
                  <Typography sx={{ fontSize: "0.62rem", color: "#94a3b8" }}>
                    Fill in doctor details
                  </Typography>
                </Box>
              </Box>

              <IconButton
                onClick={handleCloseDrawer}
                size="small"
                sx={{
                  borderRadius: "8px",
                  border: "1px solid #e5e9ef",
                  p: "5px",
                }}
              >
                <CloseIcon sx={{ fontSize: "1rem", color: "#94a3b8" }} />
              </IconButton>
            </Box>

            {/* ── BODY (MATCH PATIENT STYLE) ── */}
            <Box
              sx={{
                flex: 1,
                overflowY: "auto",
                p: 2.5,
                background: "#f8fafc",
              }}
            >
              <Grid container spacing={1.75}>
                {/* NAME */}
                <Grid item xs={12}>
                  <Typography sx={pLabelStyle}>
                    Doctor Name <Req />
                  </Typography>
                  <TextField
                    fullWidth
                    size="small"
                    name="name"
                    value={doctorData.name}
                    onChange={handleNewChange}
                    error={!!errors.name}
                    helperText={errors.name}
                    sx={pFieldStyle}
                  />
                </Grid>

                {/* REG ID */}
                <Grid item xs={12}>
                  <Typography sx={pLabelStyle}>Registration ID</Typography>
                  <TextField
                    fullWidth
                    size="small"
                    name="regId"
                    value={doctorData.regId}
                    onChange={handleNewChange}
                    sx={pFieldStyle}
                  />
                </Grid>

                {/* FEES */}
                <Grid item xs={12}>
                  <Typography sx={pLabelStyle}>Consultation Fees</Typography>
                  <TextField
                    fullWidth
                    size="small"
                    type="number"
                    name="consultFees"
                    value={doctorData.consultFees}
                    onChange={handleNewChange}
                    sx={pFieldStyle}
                  />
                </Grid>

                {/* NOTE */}
                <Grid item xs={12}>
                  <Typography sx={pLabelStyle}>Note</Typography>
                  <TextField
                    fullWidth
                    size="small"
                    name="note"
                    value={doctorData.note}
                    onChange={handleNewChange}
                    sx={pFieldStyle}
                  />
                </Grid>

                {/* DROPDOWNS */}
                <Grid item xs={12} sm={4}>
                  <Typography sx={pLabelStyle}>Is Consultant</Typography>
                  <Select
                    fullWidth
                    size="small"
                    name="isConsultant"
                    value={doctorData.isConsultant}
                    onChange={handleNewChange}
                    sx={pFieldStyle}
                  >
                    <MenuItem value={true}>Yes</MenuItem>
                    <MenuItem value={false}>No</MenuItem>
                  </Select>
                </Grid>

                <Grid item xs={12} sm={4}>
                  <Typography sx={pLabelStyle}>Is Signatory</Typography>
                  <Select
                    fullWidth
                    size="small"
                    name="isSignatory"
                    value={doctorData.isSignatory}
                    onChange={handleNewChange}
                    sx={pFieldStyle}
                  >
                    <MenuItem value={true}>Yes</MenuItem>
                    <MenuItem value={false}>No</MenuItem>
                  </Select>
                </Grid>

                <Grid item xs={12} sm={4}>
                  <Typography sx={pLabelStyle}>Category</Typography>
                  <Select
                    fullWidth
                    size="small"
                    name="signatoryCat"
                    value={doctorData.signatoryCat}
                    onChange={handleNewChange}
                    sx={pFieldStyle}
                  >
                    <MenuItem value="Pathology">Pathology</MenuItem>
                    <MenuItem value="Radiology">Radiology</MenuItem>
                    <MenuItem value="Microbiology">Microbiology</MenuItem>
                  </Select>
                </Grid>

                {/* SIGN HEADER */}
                <Grid item xs={12}>
                  <Typography sx={pLabelStyle}>Sign Header</Typography>
                  <TextField
                    fullWidth
                    size="small"
                    name="signHeader"
                    value={doctorData.signHeader}
                    onChange={handleNewChange}
                    sx={pFieldStyle}
                  />
                </Grid>

                {/* SIGNATURE FILE */}
                <Grid item xs={12}>
                  <Typography sx={pLabelStyle}>Signature</Typography>
                  <TextField
                    type="file"
                    fullWidth
                    size="small"
                    onChange={handleSignFileChange}
                    inputProps={{ accept: "image/*" }}
                    sx={pFieldStyle}
                  />
                </Grid>

                {/* QUALIFICATIONS */}
                <Grid item xs={12}>
                  <Typography sx={pLabelStyle}>
                    Qualifications <Req />
                  </Typography>

                  {doctorData.qualifications.map((qual, index) => (
                    <Box
                      key={index}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        mb: 1,
                      }}
                    >
                      <TextField
                        fullWidth
                        size="small"
                        placeholder="Enter qualification (e.g. MBBS, MD)"
                        value={qual}
                        onChange={(e) =>
                          handleQualificationChange(index, e.target.value)
                        }
                        sx={pFieldStyle}
                      />

                      {/* REMOVE BUTTON */}
                      {doctorData.qualifications.length > 1 && (
                        <IconButton
                          size="small"
                          onClick={() => removeQualification(index)}
                          sx={{
                            borderRadius: "8px",
                            border: "1px solid #e5e9ef",
                            color: "#dc2626",
                          }}
                        >
                          <DeleteIcon fontSize="small" />
                        </IconButton>
                      )}
                    </Box>
                  ))}

                  {/* ADD BUTTON */}
                  <Button
                    size="small"
                    onClick={addQualification}
                    startIcon={<AddIcon />}
                    sx={{
                      mt: 0.5,
                      textTransform: "none",
                      fontSize: "0.75rem",
                      color: "#b93acf",
                    }}
                  >
                    Add Qualification
                  </Button>

                  {/* ERROR */}
                  {errors.qualifications && (
                    <Typography
                      sx={{ fontSize: "0.7rem", color: "#dc2626", mt: 0.5 }}
                    >
                      {errors.qualifications}
                    </Typography>
                  )}
                </Grid>
              </Grid>
            </Box>

            {/* ── FOOTER (MATCH PATIENT) ── */}
            <Box
              sx={{
                px: 2.5,
                py: 2,
                background: "#ffffff",
                borderTop: "1px solid #e5e9ef",
                display: "flex",
                gap: 1.5,
              }}
            >
              <Button
                fullWidth
                variant="outlined"
                onClick={handleCloseDrawer}
                sx={{
                  borderRadius: "10px",
                  textTransform: "none",
                  fontSize: "0.82rem",
                  fontWeight: 600,
                }}
              >
                Cancel
              </Button>

              <Button
                fullWidth
                variant="contained"
                onClick={handleDoctorSubmit}
                disabled={doctorLoading}
                sx={{
                  borderRadius: "10px",
                  textTransform: "none",
                  fontWeight: 700,
                  background: "linear-gradient(135deg, #0f6e56, #1d9e75)",
                }}
              >
                {doctorLoading ? "Submitting…" : "Register Doctor"}
              </Button>
            </Box>
          </Box>
        )}

        {centerForm && (
          <Box
            component="form"
            sx={{ height: "100%", display: "flex", flexDirection: "column" }}
          >
            {/* ── HEADER (MATCH OTHERS) ── */}
            <Box
              sx={{
                px: 2.5,
                py: 1.5,
                background: "#ffffff",
                borderBottom: "1px solid #e5e9ef",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                position: "relative",
                "&::after": {
                  content: '""',
                  position: "absolute",
                  bottom: 0,
                  left: 0,
                  right: 0,
                  height: "2px",
                  background: "linear-gradient(90deg, #2a54a6, #b93acf)",
                },
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 1.25 }}>
                <Box
                  sx={{
                    width: 32,
                    height: 32,
                    borderRadius: "9px",
                    background: "linear-gradient(135deg, #2a54a6, #b93acf)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    boxShadow: "0 3px 10px rgba(185,58,207,0.25)",
                  }}
                >
                  <ApartmentIcon sx={{ color: "#fff", fontSize: "1rem" }} />
                </Box>

                <Box>
                  <Typography
                    sx={{
                      fontSize: "0.9rem",
                      fontWeight: 700,
                      color: "#0a1f44",
                    }}
                  >
                    Register Center
                  </Typography>
                  <Typography sx={{ fontSize: "0.62rem", color: "#94a3b8" }}>
                    Add new center details
                  </Typography>
                </Box>
              </Box>

              <IconButton
                onClick={handleCloseDrawer}
                size="small"
                sx={{
                  borderRadius: "8px",
                  border: "1px solid #e5e9ef",
                  p: "5px",
                }}
              >
                <CloseIcon sx={{ fontSize: "1rem", color: "#94a3b8" }} />
              </IconButton>
            </Box>

            {/* ── BODY ── */}
            <Box
              sx={{
                flex: 1,
                overflowY: "auto",
                p: 2.5,
                background: "#f8fafc",
              }}
            >
              <Grid container spacing={1.75}>
                {/* CENTER NAME */}
                <Grid item xs={12}>
                  <Typography sx={pLabelStyle}>
                    Center Name <Req />
                  </Typography>
                  <TextField
                    fullWidth
                    size="small"
                    name="centreName"
                    value={centerData.centreName}
                    onChange={handleChangeCenter}
                    sx={pFieldStyle}
                  />
                </Grid>

                {/* ADDRESS */}
                <Grid item xs={12}>
                  <Typography sx={pLabelStyle}>Address</Typography>
                  <TextField
                    fullWidth
                    size="small"
                    name="centreAddress"
                    value={centerData.centreAddress}
                    onChange={handleChangeCenter}
                    sx={pFieldStyle}
                  />
                </Grid>

                {/* CONTACT PERSON */}
                <Grid item xs={12}>
                  <Typography sx={pLabelStyle}>Contact Person</Typography>
                  <TextField
                    fullWidth
                    size="small"
                    name="centreContactPerson"
                    value={centerData.centreContactPerson}
                    onChange={handleChangeCenter}
                    sx={pFieldStyle}
                  />
                </Grid>

                {/* CONTACT NUMBER */}
                <Grid item xs={12}>
                  <Typography sx={pLabelStyle}>Contact Number</Typography>
                  <TextField
                    fullWidth
                    size="small"
                    name="centreContactNumber"
                    value={centerData.centreContactNumber}
                    onChange={handleChangeCenter}
                    sx={pFieldStyle}
                  />
                </Grid>
              </Grid>
            </Box>

            {/* ── FOOTER (MATCH SYSTEM) ── */}
            <Box
              sx={{
                px: 2.5,
                py: 2,
                background: "#ffffff",
                borderTop: "1px solid #e5e9ef",
                display: "flex",
                gap: 1.5,
              }}
            >
              {/* CANCEL */}
              <Button
                fullWidth
                variant="outlined"
                onClick={handleCloseDrawer}
                sx={{
                  borderRadius: "10px",
                  textTransform: "none",
                  fontSize: "0.82rem",
                  fontWeight: 600,
                }}
              >
                Cancel
              </Button>

              {/* SUBMIT */}
              <Button
                fullWidth
                variant="contained"
                onClick={handleSubmitCenter}
                disabled={centerLoading}
                sx={{
                  borderRadius: "10px",
                  textTransform: "none",
                  fontWeight: 700,
                  background: "linear-gradient(135deg,#16a34a,#22c55e)",
                  boxShadow: "0 6px 18px rgba(34,197,94,0.35)",
                  "&:hover": {
                    background: "linear-gradient(135deg,#15803d,#16a34a)",
                  },
                }}
              >
                {centerLoading ? "Submitting…" : "Register Center"}
              </Button>
            </Box>
          </Box>
        )}
      </Dialog>

      <Dialog
        open={openConfirmModal}
        onClose={() => !loading && setOpenConfirmModal(false)}
        maxWidth="xs"
        fullWidth
      >
        {/* HEADER */}
        <Box
          sx={{
            px: 2,
            py: 1.5,
            borderBottom: "1px solid #e5e9ef",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            background: "#fff",
          }}
        >
          <Typography sx={{ fontWeight: 700, fontSize: "0.9rem" }}>
            Confirm Bill Submission
          </Typography>

          <IconButton
            disabled={loading}
            onClick={() => setOpenConfirmModal(false)}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>

        {/* CONTENT */}
        <DialogContent sx={{ background: "#f8fafc" }}>
          <Box sx={{ position: "relative" }}>
            {/* TEXT */}
            {!displayPrintOptions && (
              <Typography sx={{ fontSize: "0.8rem", mb: 1 }}>
                Are you sure you want to submit this bill?
              </Typography>
            )}

            {/* SUMMARY BOX */}
            <Box
              sx={{
                p: 1.5,
                borderRadius: "10px",
                background: "#fff",
                border: "1px solid #e5e9ef",
                mb: 2,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              {/* LEFT */}
              <Box>
                <Typography sx={{ fontSize: "0.75rem", color: "#64748b" }}>
                  Total Tests
                </Typography>
                <Typography sx={{ fontWeight: 700, fontSize: "1rem" }}>
                  {billItems.length}
                </Typography>
              </Box>

              {/* RIGHT */}
              <Box textAlign="right">
                <Typography sx={{ fontSize: "0.75rem", color: "#64748b" }}>
                  Total Amount
                </Typography>
                <Typography
                  sx={{
                    fontWeight: 700,
                    fontSize: "1rem",
                    color: "#16a34a",
                  }}
                >
                  ₹ {discountedTotal}
                </Typography>
              </Box>
            </Box>

            {/* ACTION BUTTONS */}
            {!displayPrintOptions ? (
              // ✅ NORMAL CONFIRM UI
              <Box sx={{ display: "flex", gap: 1 }}>
                <Button
                  fullWidth
                  variant="outlined"
                  disabled={loading}
                  onClick={() => setOpenConfirmModal(false)}
                  sx={{
                    borderRadius: "10px",
                    textTransform: "none",
                  }}
                >
                  Cancel
                </Button>

                <Button
                  fullWidth
                  variant="contained"
                  disabled={loading}
                  onClick={async () => {
                    await submitBillAPI();
                  }}
                  sx={{
                    borderRadius: "10px",
                    textTransform: "none",
                    background: loading
                      ? "#e5e9ef"
                      : "linear-gradient(135deg,#16a34a,#22c55e)",
                  }}
                >
                  {loading ? "Submitting..." : "Confirm & Submit"}
                </Button>
              </Box>
            ) : (
              // 🔥 PRINT OPTIONS UI
              <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                <Typography
                  sx={{
                    fontSize: "0.8rem",
                    fontWeight: 600,
                    color: "#16a34a",
                    textAlign: "center",
                  }}
                >
                  ✅ Bill Created Successfully
                </Typography>

                <Box sx={{ display: "flex", gap: 1 }}>
                  {/* PRINT INVOICE */}
                  <Button
                    fullWidth
                    variant="outlined"
                    onClick={() => printInvoice(invoiceIdToPrint)}
                    sx={{
                      borderRadius: "10px",
                      textTransform: "none",
                    }}
                  >
                    <ReceiptIcon sx={{ color: "green" }} />
                    Print Invoice
                  </Button>

                  {/* PRINT ADVICE */}
                  <Button
                    fullWidth
                    variant="outlined"
                    onClick={() => printAdvice(invoiceIdToPrint)}
                    sx={{
                      borderRadius: "10px",
                      textTransform: "none",
                    }}
                  >
                    <DescriptionIcon sx={{ color: "#f59e0b" }} />
                    Print Advice
                  </Button>
                </Box>

                {/* PRINT BOTH */}
                <Button
                  fullWidth
                  variant="contained"
                  onClick={() => printBoth(invoiceIdToPrint)}
                  sx={{
                    borderRadius: "10px",
                    textTransform: "none",
                    background: "linear-gradient(135deg,#2a54a6,#b93acf)",
                  }}
                >
                  Print Both
                </Button>
              </Box>
            )}
          </Box>
        </DialogContent>
      </Dialog>
      {invoice && (
        <Box sx={{ display: "flex", justifyItems: "flex-start", mt: 0 }}>
          <Button onClick={cancelEditHandler} color="error">
            Cancel
          </Button>
        </Box>
      )}
      <Box
        sx={{
          p: 2,
          borderRadius: "14px",
          border: "1px solid #e5e9ef",
          background: "#fff",
          boxShadow: "0 2px 12px rgba(10,31,68,0.06)",
        }}
      >
        <Grid container spacing={1.5} marginBottom={2}>
          {/* ══ PATIENT ══ */}
          <Grid item xs={12} sm={4}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 0.75,
                mb: 0.75,
              }}
            >
              <PersonIcon sx={{ fontSize: "0.8rem", color: "#2a54a6" }} />
              <Typography
                sx={{
                  fontSize: "0.68rem",
                  fontWeight: 700,
                  color: "#0a1f44",
                  textTransform: "uppercase",
                  letterSpacing: "0.3px",
                }}
              >
                Patient
              </Typography>
              <Box
                component="span"
                sx={{ color: "#b93acf", fontWeight: 700, fontSize: "0.75rem" }}
              >
                *
              </Box>
            </Box>

            <Dialog
              open={openPatientModal}
              onClose={() => setOpenPatientModal(false)}
              maxWidth="sm"
              fullWidth
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  px: 2.5,
                  py: 1.5,
                  borderBottom: "1px solid #e5e9ef",
                  background:
                    "linear-gradient(135deg, rgba(42,84,166,0.06), rgba(185,58,207,0.05))",
                }}
              >
                {/* 🔥 TITLE SECTION */}
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Box
                    sx={{
                      width: 28,
                      height: 28,
                      borderRadius: "8px",
                      background: "linear-gradient(135deg,#2a54a6,#b93acf)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      boxShadow: "0 3px 8px rgba(185,58,207,0.25)",
                    }}
                  >
                    <PersonIcon sx={{ color: "#fff", fontSize: 16 }} />
                  </Box>

                  <Box>
                    <Typography
                      sx={{
                        fontSize: "0.85rem",
                        fontWeight: 700,
                        color: "#0a1f44",
                        lineHeight: 1.2,
                      }}
                    >
                      Select Patient
                    </Typography>

                    <Typography
                      sx={{
                        fontSize: "0.65rem",
                        color: "#94a3b8",
                      }}
                    >
                      Search or register new patient
                    </Typography>
                  </Box>
                </Box>

                {user?._doc?.permissions?.patientManagement?.create && (
                  <RegisterBtn
                    label="Register"
                    onClick={() => {
                      setPatientForm(true);
                      setIsDrawerOpen(true);
                      setOpenPatientModal(false);
                    }}
                  />
                )}
              </Box>

              <DialogContent>
                <TextField
                  fullWidth
                  placeholder="Search patient..."
                  value={patientSearchInput}
                  onChange={(e) => setPatientSearchInput(e.target.value)}
                  onKeyDown={handlePatientKeyDown} // 🔥 important
                  autoFocus
                  size="small"
                  sx={{ mb: 2 }}
                />

                {loadingPatients ? (
                  <CircularProgress size={20} />
                ) : (
                  patientSuggestions.map((p, index) => (
                    <Box
                      key={p._id}
                      sx={{
                        ...optionRowSx,
                        p: 1.2,
                        borderRadius: "8px",
                        mb: 0.5,

                        background:
                          index === highlightedIndex
                            ? "linear-gradient(135deg, rgba(42,84,166,0.12), rgba(185,58,207,0.1))"
                            : "#fff",

                        borderLeft:
                          index === highlightedIndex
                            ? "3px solid #b93acf"
                            : "3px solid transparent",

                        boxShadow:
                          index === highlightedIndex
                            ? "0 4px 10px rgba(185,58,207,0.15)"
                            : "0 1px 4px rgba(0,0,0,0.04)",

                        cursor: "pointer",
                        transition: "all 0.2s ease",

                        "&:hover": {
                          background: "rgba(42,84,166,0.06)",
                        },
                      }}
                      onMouseEnter={() => setHighlightedIndex(index)}
                      onClick={() => {
                        setFormData((prev) => ({
                          ...prev,
                          patientId: p._id,
                        }));
                        setPatientSearchInput(p.name);
                        setOpenPatientModal(false);

                        setTimeout(() => {
                          doctorInputRef.current?.focus();
                        }, 150);
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          width: "100%",
                        }}
                      >
                        <Typography
                          fontWeight={700}
                          fontSize="0.86rem"
                          color="#0f172a"
                        >
                          {p.name}
                        </Typography>
                        <Box
                          sx={{
                            fontSize: "0.68rem",
                            fontWeight: 700,
                            px: 1,
                            py: 0.2,
                            borderRadius: "6px",
                            background: "#eef2ff",
                            color: "#4f46e5",
                          }}
                        >
                          {p.patientID || "N/A"}
                        </Box>
                      </Box>

                      {/* 🔥 BOTTOM ROW */}
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          mt: 0.3,
                          width: "100%",
                        }}
                      >
                        <Typography fontSize="0.72rem" color="#64748b">
                          Age: {showAge?.(p.dob)} &nbsp;·&nbsp; Ph: {p.mobile}
                        </Typography>

                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: "4px",
                            fontSize: "0.72rem",
                            fontWeight: 600,
                            color:
                              p.gender === "Male"
                                ? "#2563eb"
                                : p.gender === "Female"
                                  ? "#db2777"
                                  : "#64748b",
                          }}
                        >
                          {p.gender || "—"}
                          {getGenderIcon?.(p.gender)}
                        </Box>
                      </Box>
                    </Box>
                  ))
                )}
              </DialogContent>
            </Dialog>

            {invoice ? (
              <TextField
                variant="outlined"
                size="small"
                fullWidth
                disabled
                value={invoice.patient.name}
                sx={disabledFieldStyle}
              />
            ) : (
              <TextField
                label="Select Patient"
                value={patientSearchInput}
                onChange={(e) => {
                  setPatientSearchInput(e.target.value);
                  setOpenPatientModal(true);
                }}
                fullWidth
                size="small"
                sx={searchFieldStyle}
              />
            )}
          </Grid>

          {/* ══ DOCTOR ══ */}
          <Grid item xs={12} sm={4}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 0.75,
                mb: 0.75,
              }}
            >
              <LocalHospitalIcon
                sx={{ fontSize: "0.8rem", color: "#2a54a6" }}
              />
              <Typography
                sx={{
                  fontSize: "0.68rem",
                  fontWeight: 700,
                  color: "#0a1f44",
                  textTransform: "uppercase",
                  letterSpacing: "0.3px",
                }}
              >
                Doctor
              </Typography>
            </Box>

            <Dialog
              open={openDoctorModal}
              onClose={() => setOpenDoctorModal(false)}
              maxWidth="sm"
              fullWidth
            >
              {/* HEADER */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  px: 2,
                  py: 1.2,
                  borderBottom: "1px solid #e5e9ef",
                  background: "#ffffff",
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Box
                    sx={{
                      width: 28,
                      height: 28,
                      borderRadius: "8px",
                      background: "linear-gradient(135deg,#2a54a6,#b93acf)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      boxShadow: "0 3px 8px rgba(185,58,207,0.25)",
                    }}
                  >
                    <PersonIcon sx={{ color: "#fff", fontSize: 16 }} />
                  </Box>

                  <Box>
                    <Typography
                      sx={{
                        fontSize: "0.85rem",
                        fontWeight: 700,
                        color: "#0a1f44",
                        lineHeight: 1.2,
                      }}
                    >
                      Select Doctor
                    </Typography>

                    <Typography
                      sx={{
                        fontSize: "0.65rem",
                        color: "#94a3b8",
                      }}
                    >
                      Search or register new doctor
                    </Typography>
                  </Box>
                </Box>

                <RegisterBtn
                  label="Register"
                  onClick={() => {
                    setDoctorForm(true);
                    setIsDrawerOpen(true);
                    setOpenDoctorModal(false);
                  }}
                />
              </Box>

              {/* CONTENT */}
              <DialogContent>
                {/* SEARCH */}
                <TextField
                  fullWidth
                  placeholder="Search doctor..."
                  value={doctorSearchInput}
                  onChange={(e) => setDoctorSearchInput(e.target.value)}
                  onKeyDown={handleDoctorKeyDown}
                  autoFocus
                  size="small"
                  sx={{ mb: 2 }}
                />

                {/* LOADING */}
                {loadingDoctors ? (
                  <CircularProgress size={20} />
                ) : (
                  doctorSuggestions?.map((doc, index) => (
                    <Box
                      key={doc._id}
                      sx={{
                        ...optionRowSx,
                        p: 1.2,
                        borderRadius: "8px",
                        mb: 0.5,

                        background:
                          index === highlightedIndex
                            ? "linear-gradient(135deg, rgba(42,84,166,0.12), rgba(185,58,207,0.1))"
                            : "#fff",

                        borderLeft:
                          index === highlightedIndex
                            ? "3px solid #b93acf"
                            : "3px solid transparent",

                        boxShadow:
                          index === highlightedIndex
                            ? "0 4px 10px rgba(185,58,207,0.15)"
                            : "0 1px 4px rgba(0,0,0,0.04)",

                        cursor: "pointer",
                        transition: "all 0.2s ease",

                        "&:hover": {
                          background: "rgba(42,84,166,0.06)",
                        },
                      }}
                      onMouseEnter={() => setHighlightedIndex(index)}
                      onClick={() => {
                        setFormData((prev) => ({
                          ...prev,
                          doctorId: doc._id,
                        }));
                        setDoctorSearchInput(doc.name);
                        setOpenDoctorModal(false);
                      }}
                    >
                      {/* 🔥 TOP ROW */}
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          width: "100%",
                        }}
                      >
                        <Typography fontWeight={700} fontSize="0.85rem">
                          {doc.name}
                        </Typography>

                        <Typography
                          sx={{
                            fontSize: "0.7rem",
                            fontWeight: 600,
                            px: 1,
                            py: 0.2,
                            borderRadius: "6px",
                            background: "#ecfdf5",
                            color: "#059669",
                          }}
                        >
                          {doc.regId || "—"}
                        </Typography>
                      </Box>

                      {/* 🔥 BOTTOM ROW */}
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          mt: 0.3,
                          width: "100%",
                        }}
                      >
                        <Typography fontSize="0.72rem" color="#64748b">
                          {doc.qualifications?.join(", ") || "—"}
                        </Typography>

                        <Typography
                          sx={{
                            fontSize: "0.72rem",
                            fontWeight: 600,
                            color: doc.isSignatory ? "#16a34a" : "#64748b",
                          }}
                        >
                          {doc.isSignatory ? "Signatory" : ""}
                        </Typography>
                      </Box>
                    </Box>
                  ))
                )}
              </DialogContent>
            </Dialog>

            {invoice && !changeDoctorClicked && invoice?.doctor?.name ? (
              <Box sx={{ display: "flex", gap: 0.75 }}>
                <TextField
                  variant="outlined"
                  size="small"
                  fullWidth
                  disabled
                  value={invoice?.doctor?.name}
                  sx={disabledFieldStyle}
                />
                <Tooltip title="Change doctor" arrow>
                  <IconButton
                    onClick={() => setChangeDoctorClicked(true)}
                    sx={editBtnSx}
                  >
                    <Edit sx={{ fontSize: "0.9rem" }} />
                  </IconButton>
                </Tooltip>
              </Box>
            ) : (
              <Box sx={{ display: "flex", gap: 0.75 }}>
                <TextField
                  inputRef={doctorInputRef}
                  label="Select Doctor"
                  value={doctorSearchInput}
                  onChange={(e) => {
                    setDoctorSearchInput(e.target.value);
                    setOpenDoctorModal(true);
                  }}
                  fullWidth
                  size="small"
                  sx={searchFieldStyle}
                />
                {invoice && (
                  <Tooltip title="Cancel change" arrow>
                    <IconButton
                      sx={clearBtnSx}
                      onClick={() => {
                        setChangeDoctorClicked(false);
                        setFormData({ ...formData, doctorId: invoice.doctor });
                      }}
                    >
                      <ClearIcon sx={{ fontSize: "0.9rem" }} />
                    </IconButton>
                  </Tooltip>
                )}
              </Box>
            )}
          </Grid>

          {/* ══ CENTRE ══ */}
          <Grid item xs={12} sm={4}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 0.75,
                mb: 0.75,
              }}
            >
              <ApartmentIcon sx={{ fontSize: "0.8rem", color: "#2a54a6" }} />
              <Typography
                sx={{
                  fontSize: "0.68rem",
                  fontWeight: 700,
                  color: "#0a1f44",
                  textTransform: "uppercase",
                  letterSpacing: "0.3px",
                }}
              >
                Centre
              </Typography>
            </Box>

            {invoice && !changeCenterClicked ? (
              <Box sx={{ display: "flex", gap: 0.75 }}>
                <TextField
                  variant="outlined"
                  size="small"
                  fullWidth
                  disabled
                  value={invoice.center.centreName}
                  sx={disabledFieldStyle}
                />
                {!invoice?.fromCentreRef && (
                  <Tooltip title="Change centre" arrow>
                    <IconButton
                      sx={editBtnSx}
                      onClick={() => setChangeCenterClicked(true)}
                    >
                      <Edit sx={{ fontSize: "0.9rem" }} />
                    </IconButton>
                  </Tooltip>
                )}
              </Box>
            ) : (
              <Box sx={{ display: "flex", gap: 0.75 }}>
                {!defaultCentre ? (
                  <>
                    <TextField
                      // inputRef={doctorInputRef}
                      label="Select Center"
                      value={centerSearchInput}
                      onChange={(e) => {
                        setCenterSearchInput(e.target.value);
                        setOpenCenterModal(true);
                      }}
                      fullWidth
                      size="small"
                      sx={searchFieldStyle}
                    />
                    {invoice && (
                      <Tooltip title="Cancel change" arrow>
                        <IconButton
                          sx={clearBtnSx}
                          onClick={() => {
                            setChangeCenterClicked(false);
                            setFormData({
                              ...formData,
                              centerId: invoice.center,
                            });
                          }}
                        >
                          <ClearIcon sx={{ fontSize: "0.9rem" }} />
                        </IconButton>
                      </Tooltip>
                    )}
                  </>
                ) : (
                  <>
                    <TextField
                      variant="outlined"
                      size="small"
                      fullWidth
                      disabled
                      label="Centre"
                      value={`${defaultCenterData?.centreName} · ${defaultCenterData?.centreId}`}
                      sx={disabledFieldStyle}
                    />
                    <Tooltip title="Change centre" arrow>
                      <IconButton
                        sx={editBtnSx}
                        onClick={() => {
                          setDefaultCentre(false);
                          setFormData((prev) => ({ ...prev, centerId: null }));
                        }}
                      >
                        <Edit sx={{ fontSize: "0.9rem" }} />
                      </IconButton>
                    </Tooltip>
                  </>
                )}
              </Box>
            )}
          </Grid>
        </Grid>

        <Grid container spacing={2.5}>
          {/* 🔥 AUTOCOMPLETE */}
          <Grid item xs={12} sm={10}>
            <Autocomplete
              options={testHeaders}
              getOptionLabel={(option) =>
                `${option.testName} (${option.testPrice})`
              }
              value={selectedTest}
              onChange={(event, newValue) => {
                setSelectedTest(newValue);
                setTimeout(() => {
                  addToBillRef.current?.focus();
                }, 100);
              }}
              onKeyDown={(e) => handleKeyDown(e)}
              disableClearable
              isOptionEqualToValue={(option, value) => option.id === value.id}
              filterOptions={(options, state) => {
                if (state.inputValue) {
                  return options.filter((option) =>
                    `${option.testName} ${option.testPrice}`
                      .toLowerCase()
                      .includes(state.inputValue.toLowerCase()),
                  );
                }
                return options.slice(0, 5);
              }}
              // 🔥 CUSTOM OPTION UI
              renderOption={(props, option) => (
                <Box
                  component="li"
                  {...props}
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    px: 1.5,
                    py: 0.8,
                    borderRadius: "8px",
                    fontSize: "0.85rem",
                    transition: "all 0.2s ease",

                    // 🔥 HOVER (light)
                    "&:hover": {
                      background: "rgba(185,58,207,0.08)",
                    },

                    // 🔥 ACTIVE ROW (keyboard selection)
                    "&.Mui-focused": {
                      background: "#b93acf !important",
                      color: "#fff",
                    },

                    // 🔥 SELECTED (clicked)
                    "&[aria-selected='true']": {
                      background: "#a21caf !important",
                      color: "#fff",
                    },
                  }}
                >
                  <span>{option.testName}</span>

                  <span
                    style={{
                      fontWeight: 600,
                      color: "inherit", // 🔥 inherit white when active
                    }}
                  >
                    ₹ {option.testPrice}
                  </span>
                </Box>
              )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  inputRef={selectTestRef}
                  label="Select Test"
                  size="small"
                  fullWidth
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "10px",
                      background: "#f8fafc",
                      fontSize: "0.85rem",
                      "& fieldset": {
                        borderColor: "#e5e9ef",
                      },
                      "&:hover fieldset": {
                        borderColor: "#2a54a6",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "#b93acf",
                        borderWidth: "1.5px",
                      },
                    },
                    "& .MuiInputLabel-root": {
                      fontSize: "0.82rem",
                      color: "#64748b",
                    },
                  }}
                />
              )}
            />
          </Grid>

          {/* 🔥 BUTTON */}
          <Grid item xs={12} sm={2}>
            <Button
              ref={addToBillRef}
              onClick={addToBill}
              disabled={!selectedTest}
              fullWidth
              sx={{
                height: "40px",
                borderRadius: "10px",
                fontWeight: 600,
                fontSize: "0.85rem",
                textTransform: "none",
                color: "#fff",
                background: "linear-gradient(135deg, #0f6e56, #1d9e75)",
                boxShadow: "0 4px 12px rgba(16,185,129,0.3)",
                "&:disabled": {
                  background: "#e5e7eb",
                  color: "#9ca3af",
                  boxShadow: "none",
                },
              }}
            >
              Add to Bill
            </Button>
          </Grid>
        </Grid>

        {/* 🔥 NOTE + DATE SECTION */}
        {/* {billItems?.length > 0 && (
          <Grid container spacing={2} mt={2}>
            <Grid item xs={12} sm={9}>
              <TextField
                label="Write Note..."
                size="small"
                fullWidth
                variant="outlined"
                value={note}
                onChange={(e) => setNote(e.target.value)}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "10px",
                    background: "#f8fafc",
                    fontSize: "0.85rem",
                    "& fieldset": { borderColor: "#e5e9ef" },
                    "&:hover fieldset": { borderColor: "#2a54a6" },
                    "&.Mui-focused fieldset": {
                      borderColor: "#b93acf",
                      borderWidth: "1.5px",
                    },
                  },
                }}
              />
            </Grid>

            <Grid item xs={12} sm={3}>
              <TextField
                label="Billing Date"
                type="date"
                size="small"
                fullWidth
                value={
                  sampleCollectedDate
                    ? dayjs(sampleCollectedDate).format("YYYY-MM-DD")
                    : ""
                }
                onChange={(e) => handleDateChange(dayjs(e.target.value))}
                inputProps={{
                  max: dayjs().format("YYYY-MM-DD"), // same maxDate logic
                }}
                InputLabelProps={{
                  shrink: true,
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "10px",
                    background: "#f8fafc",
                    fontSize: "0.85rem",
                    "& fieldset": { borderColor: "#e5e9ef" },
                    "&:hover fieldset": { borderColor: "#2a54a6" },
                    "&.Mui-focused fieldset": {
                      borderColor: "#b93acf",
                      borderWidth: "1.5px",
                    },
                  },
                }}
              />
            </Grid>
          </Grid>
        )} */}
      </Box>

      <Box sx={{ mt: 1, mb: 10 }}>
        {billItems?.length > 0 ? (
          <TableContainer
            component={Paper}
            elevation={0}
            sx={{
              mt: 1.5,
              borderRadius: "14px",
              border: "1px solid #e5e9ef",
              overflow: "hidden",
              boxShadow: "0 2px 12px rgba(10,31,68,0.06)",
            }}
          >
            <Grid container spacing={2} padding={1}>
              {/* NOTE INPUT */}
              <Grid item xs={12} sm={10}>
                <TextField
                  label="Write Note..."
                  size="small"
                  fullWidth
                  variant="outlined"
                  value={note}
                  onChange={(e) => setNote(e.target.value)}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "10px",
                      background: "#faf5ff", // soft purple tint
                      fontSize: "0.85rem",
                      transition: "all 0.25s ease",

                      "& fieldset": {
                        borderColor: "#d8b4fe", // light purple border
                      },

                      "&:hover fieldset": {
                        borderColor: "#b93acf", // main purple
                      },

                      "&.Mui-focused fieldset": {
                        borderColor: "#b93acf",
                        borderWidth: "1.5px",
                        boxShadow: "0 0 0 3px rgba(185,58,207,0.15)", // glow effect 🔥
                      },

                      "& input": {
                        color: "#0a1f44",
                        fontWeight: 500,
                      },
                    },

                    "& .MuiInputLabel-root": {
                      color: "#7c3aed", // purple label
                      fontSize: "0.8rem",
                    },

                    "& .MuiInputLabel-root.Mui-focused": {
                      color: "#b93acf",
                    },
                  }}
                />
              </Grid>

              {/* DATE PICKER */}
              <Grid item xs={12} sm={2}>
                <TextField
                  label="Billing Date"
                  type="date"
                  size="small"
                  fullWidth
                  value={
                    sampleCollectedDate
                      ? dayjs(sampleCollectedDate).format("YYYY-MM-DD")
                      : ""
                  }
                  onChange={(e) => handleDateChange(dayjs(e.target.value))}
                  inputProps={{
                    max: dayjs().format("YYYY-MM-DD"), // same maxDate logic
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "10px",
                      background: "#faf5ff", // soft purple tint
                      fontSize: "0.85rem",
                      transition: "all 0.25s ease",

                      "& fieldset": {
                        borderColor: "#d8b4fe", // light purple border
                      },

                      "&:hover fieldset": {
                        borderColor: "#b93acf", // main purple
                      },

                      "&.Mui-focused fieldset": {
                        borderColor: "#b93acf",
                        borderWidth: "1.5px",
                        boxShadow: "0 0 0 3px rgba(185,58,207,0.15)", // glow effect 🔥
                      },

                      "& input": {
                        color: "#0a1f44",
                        fontWeight: 500,
                      },
                    },

                    "& .MuiInputLabel-root": {
                      color: "#7c3aed", // purple label
                      fontSize: "0.8rem",
                    },

                    "& .MuiInputLabel-root.Mui-focused": {
                      color: "#b93acf",
                    },
                  }}
                />
              </Grid>
            </Grid>
            <Table sx={{ minWidth: 650 }}>
              {/* ── Head ── */}
              <TableHead>
                <TableRow
                  sx={{
                    background:
                      "linear-gradient(135deg, rgba(42,84,166,0.05), rgba(185,58,207,0.03))",
                    "& .MuiTableCell-head": {
                      fontSize: "0.65rem",
                      fontWeight: 700,
                      color: "#64748b",
                      textTransform: "uppercase",
                      letterSpacing: "0.6px",
                      py: "10px",
                      px: "14px",
                      borderBottom: "1px solid #e5e9ef",
                      whiteSpace: "nowrap",
                    },
                  }}
                >
                  <TableCell>Test</TableCell>
                  <TableCell>Price</TableCell>
                  <TableCell>Discount</TableCell>
                  <TableCell>Type</TableCell>
                  <TableCell>Net Price</TableCell>
                  <TableCell align="center">Action</TableCell>
                </TableRow>
              </TableHead>

              {/* ── Body ── */}
              <TableBody>
                {billItems.map((item, index) => (
                  <TableRow
                    key={item._id}
                    sx={{
                      background:
                        highlightedIndex === index
                          ? "#caffc1" //"linear-gradient(135deg, rgba(42,84,166,0.05), rgba(185,58,207,0.03))"
                          : index % 2 === 0
                            ? "#ffffff"
                            : "#fafbfc",
                      "&:hover": {
                        background: "rgba(42,84,166,0.03)",
                      },
                      transition: "background 0.2s ease",
                      "& .MuiTableCell-root": {
                        py: "8px",
                        px: "14px",
                        fontSize: "0.83rem",
                        color: "#374151",
                        borderBottom: "1px solid #f1f5f9",
                      },
                      "&:last-child .MuiTableCell-root": { borderBottom: 0 },
                    }}
                  >
                    {/* Test name */}
                    <TableCell>
                      <Box
                        sx={{ display: "flex", alignItems: "center", gap: 1 }}
                      >
                        <Box
                          sx={{
                            width: 28,
                            height: 28,
                            borderRadius: "8px",
                            background:
                              "linear-gradient(135deg, rgba(42,84,166,0.1), rgba(185,58,207,0.08))",
                            border: "1px solid rgba(185,58,207,0.15)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexShrink: 0,
                          }}
                        >
                          <ScienceIcon
                            sx={{ fontSize: "0.8rem", color: "#2a54a6" }}
                          />
                        </Box>
                        <Typography
                          sx={{
                            fontSize: "0.83rem",
                            fontWeight: 600,
                            color: "#0a1f44",
                          }}
                        >
                          {item.testName}
                        </Typography>
                      </Box>
                    </TableCell>

                    {/* Price */}
                    <TableCell>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 0.75,
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: "0.83rem",
                            fontWeight: 600,
                            color: "#0a1f44",
                          }}
                        >
                          ₹{item.changedPrice || item.testPrice}
                        </Typography>
                        {user?._doc?.permissions?.testHeaderManagement
                          ?.edit && (
                          <Box
                            component="span"
                            onClick={() => changePrice(item)}
                            sx={{
                              fontSize: "0.65rem",
                              fontWeight: 600,
                              color: "#2a54a6",
                              cursor: "pointer",
                              background: "rgba(42,84,166,0.08)",
                              border: "1px solid rgba(42,84,166,0.18)",
                              borderRadius: "4px",
                              px: "5px",
                              py: "1px",
                              "&:hover": {
                                background:
                                  "linear-gradient(135deg,#2a54a6,#b93acf)",
                                color: "#fff",
                                borderColor: "transparent",
                              },
                              transition: "all 0.2s",
                            }}
                          >
                            Edit
                          </Box>
                        )}
                      </Box>
                    </TableCell>

                    {/* Discount input */}
                    <TableCell sx={{ width: "120px" }}>
                      <TextField
                        value={
                          item.discountValue !== 0 ? item.discountValue : ""
                        }
                        onChange={(e) =>
                          handleDiscountChange(
                            item._id,
                            "discountValue",
                            e.target.value,
                          )
                        }
                        size="small"
                        sx={{
                          width: "90px",
                          "& .MuiOutlinedInput-root": {
                            borderRadius: "8px",
                            background: "#f8fafc",
                            fontSize: "0.82rem",
                            "& fieldset": { borderColor: "#e5e9ef" },
                            "&:hover fieldset": { borderColor: "#2a54a6" },
                            "&.Mui-focused fieldset": {
                              borderColor: "#b93acf",
                              borderWidth: "1.5px",
                            },
                            "& input": {
                              py: "5px",
                              px: "8px",
                              textAlign: "center",
                            },
                          },
                        }}
                      />
                    </TableCell>

                    {/* Discount type */}
                    <TableCell sx={{ width: "80px" }}>
                      <Select
                        value={item.discountType}
                        onChange={(e) =>
                          handleDiscountChange(
                            item._id,
                            "discountType",
                            e.target.value,
                          )
                        }
                        size="small"
                        sx={{
                          width: "64px",
                          borderRadius: "8px",
                          background: "#f8fafc",
                          fontSize: "0.82rem",
                          fontWeight: 600,
                          "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#e5e9ef",
                          },
                          "&:hover .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#2a54a6",
                          },
                          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#b93acf",
                            borderWidth: "1.5px",
                          },
                          "& .MuiSelect-select": { py: "5px", px: "8px" },
                        }}
                      >
                        <MenuItem
                          value="%"
                          sx={{ fontSize: "0.82rem", fontWeight: 600 }}
                        >
                          %
                        </MenuItem>
                        <MenuItem
                          value="₹"
                          sx={{ fontSize: "0.82rem", fontWeight: 600 }}
                        >
                          ₹
                        </MenuItem>
                      </Select>
                    </TableCell>

                    {/* Net price */}
                    <TableCell>
                      <Box
                        sx={{
                          display: "inline-flex",
                          alignItems: "center",
                          gap: 0.5,
                          background:
                            item.discountValue && item.discountValue !== 0
                              ? "rgba(16,185,129,0.08)"
                              : "transparent",
                          border:
                            item.discountValue && item.discountValue !== 0
                              ? "1px solid rgba(16,185,129,0.2)"
                              : "none",
                          borderRadius: "6px",
                          px:
                            item.discountValue && item.discountValue !== 0
                              ? "8px"
                              : 0,
                          py:
                            item.discountValue && item.discountValue !== 0
                              ? "3px"
                              : 0,
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: "0.85rem",
                            fontWeight: 700,
                            color:
                              item.discountValue && item.discountValue !== 0
                                ? "#059669"
                                : "#0a1f44",
                          }}
                        >
                          ₹{calculateDiscountedPrice(item)?.toFixed(2)}
                        </Typography>
                        {/* {item.discountValue && item.discountValue !== 0 && (
                          <DiscountIcon
                            sx={{ fontSize: "0.7rem", color: "#10b981" }}
                          />
                        )} */}
                      </Box>
                    </TableCell>

                    {/* Delete */}
                    <TableCell align="center">
                      <Tooltip title="Remove from bill" arrow placement="left">
                        <IconButton
                          onClick={() => removeFromBill(item._id)}
                          size="small"
                          sx={{
                            width: 30,
                            height: 30,
                            borderRadius: "8px",
                            background: "rgba(239,68,68,0.07)",
                            border: "1px solid rgba(239,68,68,0.18)",
                            "&:hover": {
                              background: "rgba(239,68,68,0.15)",
                              borderColor: "rgba(239,68,68,0.35)",
                            },
                            transition: "all 0.2s",
                          }}
                        >
                          <DeleteIcon
                            sx={{ fontSize: "0.9rem", color: "#dc2626" }}
                          />
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>

            {/* ── Row count footer ── */}
            <Box
              sx={{
                px: 2,
                py: 1,
                borderTop: "1px solid #f1f5f9",
                background:
                  "linear-gradient(135deg, rgba(42,84,166,0.03), rgba(185,58,207,0.02))",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography
                sx={{ fontSize: "0.72rem", color: "#94a3b8", fontWeight: 500 }}
              >
                {billItems.length} test{billItems.length !== 1 ? "s" : ""} added
              </Typography>
              <Box
                sx={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 0.75,
                  background:
                    "linear-gradient(135deg, rgba(42,84,166,0.1), rgba(185,58,207,0.08))",
                  border: "1px solid rgba(185,58,207,0.18)",
                  borderRadius: "100px",
                  px: 1.25,
                  py: 0.4,
                }}
              >
                <Typography
                  sx={{ fontSize: "0.7rem", color: "#64748b", fontWeight: 500 }}
                >
                  Subtotal:
                </Typography>
                <Typography
                  sx={{
                    fontSize: "0.78rem",
                    fontWeight: 800,
                    background: "linear-gradient(135deg,#2a54a6,#b93acf)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    backgroundClip: "text",
                    fontFamily: "monospace",
                  }}
                >
                  ₹
                  {billItems
                    .reduce(
                      (sum, item) =>
                        sum + (calculateDiscountedPrice(item) || 0),
                      0,
                    )
                    .toFixed(2)}
                </Typography>
              </Box>
            </Box>
          </TableContainer>
        ) : (
          /* ── Empty state ── */
          <Box
            sx={{
              mt: 2,
              border: "2px dashed #e5e9ef",
              borderRadius: "14px",
              py: 5,
              px: 3,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 1.5,
              background: "#fafbfc",
            }}
          >
            <Box
              sx={{
                width: 56,
                height: 56,
                borderRadius: "16px",
                background:
                  "linear-gradient(135deg, rgba(42,84,166,0.1), rgba(185,58,207,0.08))",
                border: "1.5px solid rgba(185,58,207,0.18)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <ReceiptLongIcon sx={{ fontSize: "1.5rem", color: "#94a3b8" }} />
            </Box>
            <Typography
              sx={{ fontSize: "0.95rem", fontWeight: 700, color: "#0a1f44" }}
            >
              No tests added yet
            </Typography>
            <Typography
              sx={{
                fontSize: "0.8rem",
                color: "#94a3b8",
                textAlign: "center",
                maxWidth: 280,
              }}
            >
              Search and select a test above, then click{" "}
              <strong>Add to Bill</strong> to build the invoice.
            </Typography>
          </Box>
        )}
      </Box>
      {billItems?.length > 0 && (
        <>
          <Tooltip title="Open bill summary" arrow placement="left">
            <Button
              variant="contained"
              onClick={() => setIsBillSummaryOpen(true)}
              startIcon={<ReceiptLongIcon />}
              sx={{
                position: "fixed",
                right: { xs: 16, sm: 24 },
                bottom: { xs: 16, sm: 24 },
                zIndex: 1200,
                borderRadius: "12px",
                px: 2,
                py: 1.1,
                textTransform: "none",
                fontWeight: 700,
                background: "linear-gradient(135deg,#2a54a6,#b93acf)",
                boxShadow: "0 8px 20px rgba(42,84,166,.28)",
                "&:hover": {
                  background: "linear-gradient(135deg,#1e3a8a,#a21caf)",
                },
              }}
            >
              Bill Summary
            </Button>
          </Tooltip>

          <Drawer
            anchor="right"
            open={isBillSummaryOpen}
            onClose={() => setIsBillSummaryOpen(false)}
            PaperProps={{
              sx: {
                width: { xs: "100%", sm: 390 },
                maxWidth: "100vw",
                bgcolor: "#f8fafc",
                boxShadow: "-12px 0 32px rgba(15,23,42,.16)",
                display: "flex",
                flexDirection: "column",
              },
            }}
          >
            <Box
              sx={{
                px: 2,
                py: 1.5,
                bgcolor: "#fff",
                borderBottom: "1px solid #e5e9ef",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Box>
                <Typography
                  sx={{ fontSize: ".95rem", fontWeight: 800, color: "#0a1f44" }}
                >
                  Bill Summary
                </Typography>
                <Typography
                  sx={{ mt: 0.2, fontSize: ".7rem", color: "#64748b" }}
                >
                  Discount, collection and submission
                </Typography>
              </Box>
              <IconButton
                onClick={() => setIsBillSummaryOpen(false)}
                size="small"
                aria-label="Close bill summary"
                sx={{ border: "1px solid #e5e9ef", borderRadius: "8px" }}
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            </Box>

            <Box sx={{ flex: 1, overflowY: "auto", p: 2 }}>
              <Box
                sx={{
                  mb: 2,
                  p: 1.5,
                  borderRadius: "14px",
                  color: "#fff",
                  background: "linear-gradient(135deg, #047857, #10b981)",
                  boxShadow: "0 8px 22px rgba(16, 185, 129, 0.22)",
                }}
              >
                <Typography
                  sx={{
                    fontSize: ".68rem",
                    opacity: 0.82,
                    fontWeight: 700,
                    letterSpacing: ".6px",
                  }}
                >
                  AMOUNT PAYABLE
                </Typography>

                <Typography
                  sx={{
                    mt: 0.35,
                    fontSize: "1.75rem",
                    fontWeight: 800,
                    lineHeight: 1.1,
                  }}
                >
                  ₹{discountedTotal}
                </Typography>

                <Typography
                  sx={{
                    mt: 0.6,
                    fontSize: ".68rem",
                    opacity: 0.82,
                  }}
                >
                  {billItems.length} test{billItems.length !== 1 ? "s" : ""}{" "}
                  selected · Base total ₹{totalAmount}
                </Typography>
              </Box>

              <Box
                sx={{
                  mb: 2,
                  border: "1px solid #e2e8f0",
                  borderRadius: "12px",
                  overflow: "hidden",
                  bgcolor: "#fff",
                }}
              >
                <Box
                  sx={{
                    px: 1.5,
                    py: 1.1,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    bgcolor: "#f8fafc",
                    borderBottom: "1px solid #e2e8f0",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: ".75rem",
                      fontWeight: 800,
                      color: "#334155",
                    }}
                  >
                    Tests in this bill
                  </Typography>
                  <Box
                    sx={{
                      px: 0.8,
                      py: 0.25,
                      borderRadius: "999px",
                      bgcolor: "#eef2ff",
                      color: "#4338ca",
                      fontSize: ".64rem",
                      fontWeight: 800,
                    }}
                  >
                    {billItems.length}
                  </Box>
                </Box>

                <Box sx={{ height: 210, overflowY: "auto" }}>
                  {billItems.length === 0 ? (
                    <Box
                      sx={{
                        height: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "#94a3b8",
                        fontSize: ".75rem",
                        fontWeight: 600,
                      }}
                    >
                      No tests in this bill
                    </Box>
                  ) : (
                    billItems.map((item, index) => {
                      const basePrice = Number(
                        item.changedPrice || item.testPrice || 0,
                      );
                      const itemDiscount = Number(item.discountValue || 0);

                      return (
                        <Box
                          key={item._id}
                          sx={{
                            px: 1.5,
                            py: 1.15,
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                            borderBottom:
                              index < billItems.length - 1
                                ? "1px solid #f1f5f9"
                                : "none",
                          }}
                        >
                          <Box
                            sx={{
                              width: 29,
                              height: 29,
                              flexShrink: 0,
                              display: "grid",
                              placeItems: "center",
                              borderRadius: "8px",
                              bgcolor: "#eff6ff",
                              color: "#2563eb",
                            }}
                          >
                            <ScienceIcon sx={{ fontSize: ".9rem" }} />
                          </Box>
                          <Box sx={{ minWidth: 0, flex: 1 }}>
                            <Typography
                              noWrap
                              sx={{
                                fontSize: ".73rem",
                                fontWeight: 700,
                                color: "#334155",
                              }}
                            >
                              {item.testName}
                            </Typography>
                            <Typography
                              sx={{
                                mt: 0.15,
                                fontSize: ".62rem",
                                color: "#94a3b8",
                              }}
                            >
                              ₹{basePrice.toFixed(2)}
                              {itemDiscount > 0
                                ? ` · ${itemDiscount}${item.discountType || "%"} discount`
                                : " · No discount"}
                            </Typography>
                          </Box>
                          <Typography
                            sx={{
                              fontSize: ".75rem",
                              fontWeight: 800,
                              color: "#059669",
                              whiteSpace: "nowrap",
                            }}
                          >
                            ₹{calculateDiscountedPrice(item).toFixed(2)}
                          </Typography>
                        </Box>
                      );
                    })
                  )}
                </Box>
              </Box>
            </Box>

            {/* ================= BILL ADJUSTMENTS (Fixed at bottom above submit bill button) ================= */}
            <Box
              sx={{
                px: 2,
                pt: 1.5,
                pb: 1,
                bgcolor: "#fff",
                borderTop: "1px solid #e2e8f0",
                boxShadow: "0 -4px 16px rgba(15,23,42,.04)",
                flexShrink: 0,
              }}
            >
              {/* Section Header */}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 0.8,
                  mb: 1,
                }}
              >
                <ReceiptLongOutlinedIcon
                  sx={{
                    fontSize: "0.95rem",
                    color: "#475569",
                  }}
                />

                <Typography
                  sx={{
                    fontSize: ".72rem",
                    fontWeight: 800,
                    color: "#475569",
                    letterSpacing: ".5px",
                  }}
                >
                  BILL ADJUSTMENTS
                </Typography>
              </Box>

              {/* Adjustment Card */}
              <Box
                sx={{
                  border: "1px solid #e2e8f0",
                  borderRadius: "12px",
                  bgcolor: "#fff",
                  overflow: "hidden",
                }}
              >
                {/* Total */}
                <Box
                  sx={{
                    px: 1.5,
                    py: 1,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    borderBottom: "1px solid #f1f5f9",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                    }}
                  >
                    <Box
                      sx={{
                        width: 28,
                        height: 28,
                        borderRadius: "8px",
                        display: "grid",
                        placeItems: "center",
                        bgcolor: "#f1f5f9",
                        color: "#475569",
                      }}
                    >
                      <AccountBalanceWalletOutlinedIcon
                        sx={{ fontSize: ".9rem" }}
                      />
                    </Box>

                    <Typography
                      sx={{
                        fontSize: ".75rem",
                        fontWeight: 600,
                        color: "#64748b",
                      }}
                    >
                      Subtotal
                    </Typography>
                  </Box>

                  <Typography
                    sx={{
                      fontSize: ".9rem",
                      fontWeight: 800,
                      color: "#0f172a",
                      fontFamily: "monospace",
                    }}
                  >
                    ₹{Number(totalAmount || 0).toFixed(2)}
                  </Typography>
                </Box>

                {/* Discount */}
                <Box
                  sx={{
                    px: 1.5,
                    py: 1,
                    borderBottom: "1px solid #f1f5f9",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                    }}
                  >
                    <Box
                      sx={{
                        width: 28,
                        height: 28,
                        flexShrink: 0,
                        borderRadius: "8px",
                        display: "grid",
                        placeItems: "center",
                        bgcolor: "#fff7ed",
                        color: "#ea580c",
                      }}
                    >
                      <LocalOfferOutlinedIcon sx={{ fontSize: ".9rem" }} />
                    </Box>

                    <TextField
                      fullWidth
                      label="Discount"
                      variant="outlined"
                      value={discount != 0 ? discount : ""}
                      onChange={handleDiscountChangeTotal}
                      size="small"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "8px",
                          fontSize: ".8rem",
                          bgcolor: "#fff",
                        },

                        "& .MuiInputLabel-root": {
                          fontSize: ".75rem",
                        },

                        "& .MuiInputBase-input": {
                          fontWeight: 600,
                        },
                      }}
                    />

                    {/* Discount Type */}
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        p: "3px",
                        border: "1px solid #e2e8f0",
                        borderRadius: "8px",
                        bgcolor: "#f8fafc",
                        flexShrink: 0,
                      }}
                    >
                      {["₹", "%"].map((val) => {
                        const isActive = discountType === val;

                        return (
                          <Box
                            key={val}
                            onClick={() =>
                              handleDiscountTypeChange({
                                target: { value: val },
                              })
                            }
                            sx={{
                              minWidth: 32,
                              height: 28,
                              px: 0.8,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              borderRadius: "6px",
                              cursor: "pointer",
                              fontSize: ".72rem",
                              fontWeight: 800,
                              color: isActive ? "#fff" : "#64748b",
                              bgcolor: isActive ? "#475569" : "transparent",
                              transition: "all .15s ease",

                              "&:hover": {
                                bgcolor: isActive ? "#334155" : "#e2e8f0",
                              },
                            }}
                          >
                            {val}
                          </Box>
                        );
                      })}
                    </Box>
                  </Box>
                </Box>

                {/* Discounted Total */}
                <Box
                  sx={{
                    px: 1.5,
                    py: 1.1,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    bgcolor: "#f8fafc",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                    }}
                  >
                    <Box
                      sx={{
                        width: 28,
                        height: 28,
                        borderRadius: "8px",
                        display: "grid",
                        placeItems: "center",
                        bgcolor: "#ecfdf5",
                        color: "#059669",
                      }}
                    >
                      <CheckCircleOutlineIcon sx={{ fontSize: ".9rem" }} />
                    </Box>

                    <Box>
                      <Typography
                        sx={{
                          fontSize: ".76rem",
                          fontWeight: 700,
                          color: "#334155",
                        }}
                      >
                        Net Amount
                      </Typography>

                      <Typography
                        sx={{
                          fontSize: ".62rem",
                          color: "#94a3b8",
                          mt: 0.15,
                        }}
                      >
                        After discount
                      </Typography>
                    </Box>
                  </Box>

                  <Typography
                    sx={{
                      fontSize: "1.05rem",
                      fontWeight: 900,
                      color: "#059669",
                      fontFamily: "monospace",
                    }}
                  >
                    ₹{Number(discountedTotal || 0).toFixed(2)}
                  </Typography>
                </Box>
              </Box>
            </Box>

            <Box
              sx={{
                p: 2,
                pt: 1.25,
                bgcolor: "#fff",
                borderTop: "1px solid #f1f5f9",
                flexShrink: 0,
              }}
            >
              <Box
                sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1.25 }}
              >
                <Box
                  onClick={() =>
                    handleCheckBoxChange({ target: { checked: !checked } })
                  }
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 0.55,
                    px: 1,
                    py: 0.45,
                    borderRadius: "8px",
                    cursor: "pointer",
                    bgcolor: checked ? "#eef2ff" : "#f8fafc",
                    border: checked ? "1px solid #c7d2fe" : "1px solid #e2e8f0",
                  }}
                >
                  <Checkbox
                    size="small"
                    checked={checked}
                    sx={{
                      p: 0,
                      color: "#64748b",
                      "&.Mui-checked": { color: "#4f46e5" },
                    }}
                  />
                  <Typography
                    sx={{
                      fontSize: ".68rem",
                      fontWeight: 700,
                      color: "#475569",
                    }}
                  >
                    Collected at center
                  </Typography>
                </Box>

                {(!invoice || invoice?.fromCentreRef) && (
                  <TextField
                    label="Collected amount"
                    value={amountCollected ?? ""}
                    size="small"
                    onChange={handleAmountCollection}
                    sx={{
                      flex: 1,
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "8px",
                        fontSize: ".78rem",
                      },
                      "& .MuiInputLabel-root": { fontSize: ".72rem" },
                    }}
                  />
                )}
              </Box>

              {!loading ? (
                !displayPrintOptions ? (
                  <Button
                    ref={
                      !invoice || invoice?.fromCentreRef
                        ? submitBtnRef
                        : updateBtnRef
                    }
                    fullWidth
                    variant="contained"
                    onClick={
                      !invoice || invoice?.fromCentreRef
                        ? () => setOpenConfirmModal(true)
                        : () => updateBill(invoice._id)
                    }
                    startIcon={
                      !invoice || invoice?.fromCentreRef ? (
                        <LibraryAddCheckIcon />
                      ) : (
                        <GradingIcon />
                      )
                    }
                    sx={{
                      height: 48,
                      borderRadius: "10px",
                      textTransform: "none",
                      fontWeight: 800,
                      fontSize: ".86rem",
                      background:
                        !invoice || invoice?.fromCentreRef
                          ? "linear-gradient(135deg,#4338ca,#7e22ce)"
                          : "linear-gradient(135deg,#ea580c,#f97316)",
                      boxShadow: "0 6px 16px rgba(67,56,202,.24)",
                    }}
                  >
                    {!invoice || invoice?.fromCentreRef
                      ? "Submit Bill"
                      : "Update Bill"}
                  </Button>
                ) : (
                  <Box
                    sx={{
                      display: "flex",
                      gap: 1,
                    }}
                  >
                    <Button
                      fullWidth
                      variant="outlined"
                      startIcon={<ReceiptOutlinedIcon />}
                      onClick={() => handleInvoiceClick(invoiceIdToPrint)}
                      sx={{
                        height: 40,
                        borderRadius: "8px",
                        textTransform: "none",
                        fontSize: ".78rem",
                        fontWeight: 700,
                        color: "#047857",
                        borderColor: "#a7f3d0",
                        bgcolor: "#fff",

                        "&:hover": {
                          borderColor: "#059669",
                          bgcolor: "#ecfdf5",
                        },
                      }}
                    >
                      Invoice
                    </Button>

                    <Button
                      fullWidth
                      variant="outlined"
                      startIcon={<DescriptionOutlinedIcon />}
                      onClick={() => handleAdviceClick(invoiceIdToPrint)}
                      sx={{
                        height: 40,
                        borderRadius: "8px",
                        textTransform: "none",
                        fontSize: ".78rem",
                        fontWeight: 700,
                        color: "#047857",
                        borderColor: "#a7f3d0",
                        bgcolor: "#fff",

                        "&:hover": {
                          borderColor: "#059669",
                          bgcolor: "#ecfdf5",
                        },
                      }}
                    >
                      Advice
                    </Button>

                    <Button
                      fullWidth
                      variant="contained"
                      startIcon={<PrintOutlinedIcon />}
                      onClick={() => handleBothClick(invoiceIdToPrint)}
                      sx={{
                        height: 40,
                        borderRadius: "8px",
                        textTransform: "none",
                        fontSize: ".78rem",
                        fontWeight: 800,
                        color: "#fff",
                        background: "linear-gradient(135deg, #047857, #059669)",
                        boxShadow: "0 4px 10px rgba(5, 150, 105, 0.2)",

                        "&:hover": {
                          background:
                            "linear-gradient(135deg, #065f46, #047857)",
                          boxShadow: "0 6px 14px rgba(5, 150, 105, 0.25)",
                        },
                      }}
                    >
                      Both
                    </Button>
                  </Box>
                )
              ) : (
                <Button
                  fullWidth
                  disabled
                  variant="contained"
                  sx={{ height: 48, borderRadius: "10px" }}
                >
                  Processing…
                </Button>
              )}
            </Box>
          </Drawer>
        </>
      )}
    </>
  );
};

export default LabTest;

const pLabelStyle = {
  fontSize: "0.68rem",
  fontWeight: 600,
  color: "#0a1f44",
  letterSpacing: "0.2px",
  mb: 0.6,
  display: "flex",
  alignItems: "center",
  gap: "2px",
};

const pFieldStyle = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "10px",
    background: "#ffffff",
    fontSize: "0.875rem",
    "& fieldset": { borderColor: "#e5e9ef" },
    "&:hover fieldset": { borderColor: "#2a54a6" },
    "&.Mui-focused fieldset": { borderColor: "#b93acf", borderWidth: "1.5px" },
  },
};

const Req = () => (
  <Box component="span" sx={{ color: "#b93acf", fontWeight: 700, ml: "2px" }}>
    *
  </Box>
);
